import React from "react";
import {
  Page,
  Navbar,
  NavLeft,
  NavTitle,
  NavRight,
  Link,
  Block,
  BlockTitle,
  Toolbar,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  List,
  ListInput,
  ListItem,
  Icon,
  Button,
  Row,
  Col,
  Preloader,
} from "framework7-react";

import QRCode from "qrcode.react";

import {
  PrimaryLogo,
  MerchantSvg,
  BikeSvg,
  AgentSvg,
  BlankDetailSvg,
  MealSvg,
} from "../components/crumbs";

import cities from "../static/ng.json";

// Redux
import { connect } from "react-redux";
import { compose } from "redux";
import axios from "axios";
import {
  withFirestore,
  firebaseConnect,
  firestoreConnect,
  withStorage,
} from "../HOCs";
import { Doc } from "../utils/_classes";
import {
  toast,
  uploadFile,
  reverseGeocoding,
  handleErrors,
  deleteFiles,
  isAllowed,
  isAllowedVendorsAndAgents,
  sendOneTimePassword,
  verifyOneTimePassword,
  isValidEmail,
} from "../utils/_helpers";

// moment
import moment from "moment";

import GoogleMapReact from "google-map-react";
import Marker from "../components/marker";

class Account extends React.Component {
  constructor(props) {
    super(props);
    var tab = props.f7route.params.tab;

    this.state = {
      popupOpened: false,
      popupDataChanged: true,

      // profile address field autocomplete interval
      profileInterval: null,

      // edit images values
      image: null,
      displayImageSrc: "",

      maps: null,

      which: "",

      showTab: tab,

      edit: false,
      updateProfileButton: "Save Profile",
      profile: {
        phoneNumber: "",
        fullName: "",
        email: "",
        homeLocation: {
          address: "",
          geoLoc: null,
        },
        workLocation: {
          address: "",
          geoLoc: null,
        },
      },
      merchantEdit: false,
      updateMerchantButton: "Save",
      merchant: {
        businessLogo: "",
        name: "",
        phone: "",
        email: "",
        address: "",
        slogan: "",
        state: "",
        city: "",
        geoLoc: {
          lat: "",
          lng: "",
        },
      },
      deliveryEdit: false,
      updateDeliveryButton: "Save",
      delivery: {
        businessLogo: "",
        name: "",
        phone: "",
        email: "",
        address: "",
        slogan: "",
        category: "",
        state: "",
        city: "",
        geoLoc: {
          lat: "",
          lng: "",
        },
      },

      partnersEdit: false,
      updatePartnersButton: "Save",
      partners: {
        businessLogo: "",
        name: "",
        phone: "",
        email: "",
        address: "",
        state: "",
        city: "",
        geoLoc: {
          lat: "",
          lng: "",
        },
      },
      featuresEasychawAgent: [
        "Agent referral bonus",
        "Updates and alerts",
        "Funds withdrawal",
        "Bonus tracking dashboard",
      ],
      featuresAgent: [
        "Agent sign up bonus",
        "Expense tracking sheet",
        "Delivery report",
        "Order tracking dashboard",
      ],
      featuresMerchant: [
        "Merchant sign up bonus",
        "Expense tracking sheet",
        "Sales report",
        "Featured store front",
      ],
      deliveryAgents: {
        delivery: true,
      },
    };
  }

  // function to move users location icon the the position clicked by the user on the map
  mapClicked({ lat, lng }) {
    this.setState({
      ...this.state,
      [this.state.which]: {
        ...this.state[this.state.which],

        geoLoc: {
          lat,
          lng,
        },
      },
    });

    if (this.state.maps) {
      reverseGeocoding(
        new this.state.maps.Geocoder(),
        { lat, lng },
        (error, result) => {
          if (error) {
            return this.setState({
              ...this.state,
              [this.state.which]: {
                ...this.state[this.state.which],
                address: "",
              },
            });
          }

          this.setState({
            ...this.state,
            [this.state.which]: {
              ...this.state[this.state.which],
              address: result,
            },
          });
        },
      );
    }
  }

  // Add google autocomplete API to address input field as soon as google API object loads
  addAutoComplete({ map, maps }) {
    const self = this;
    self.setState({
      ...self.state,
      maps,
    });

    const inputAddress =
      this.state.which === "merchant"
        ? "#merchant_business_address input"
        : this.state.which === "delivery"
        ? "#delivery_business_address input"
        : "#partners_business_address input";

    const input = document.querySelector(inputAddress);
    self.autocomplete = new maps.places.Autocomplete(input);
    self.autocomplete.setFields(["formatted_address", "geometry"]);
    self.autocomplete.bindTo("bounds", map);
    self.autocomplete.addListener("place_changed", () => {
      let response = self.autocomplete.getPlace();
      if (!response.geometry) {
        this.setState({
          ...this.state,
          [this.state.which]: {
            ...this.state[this.state.which],
            address: "",
          },
        });

        return toast(self.$f7.toast, {
          text: `No details available for input: ${response.name}. Please make sure you select a suggestted place`,
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      }

      if (response) {
        this.setState({
          ...this.state,
          [this.state.which]: {
            ...this.state[this.state.which],

            address: response.formatted_address,
            geoLoc: {
              lat: response.geometry.location.lat(),
              lng: response.geometry.location.lng(),
            },
          },
        });
      }
    });
  }

  componentWillUnmount() {
    if (this.state.maps && this.autocomplete) {
      this.state.maps.event.clearInstanceListeners(this.autocomplete);
    }

    if (this.state.profileInterval) {
      clearInterval(this.state.profileInterval);
    }
  }

  render() {
    if (!this.props.auth.isLoaded || !this.props.profile.isLoaded) {
      //return ' '
    }

    return (
      <Page id="account-page" onPageAfterIn={this.onPageAfterIn.bind(this)}>
        <Navbar sliding={false}>
          <NavLeft>
            <Link iconF7="bars" panelOpen="left" />
          </NavLeft>
          <NavTitle sliding>
            {" "}
            {this.state.showTab == "info" ? "Info" : "Account"}{" "}
          </NavTitle>
          {/* <NavRight>
            <Link
              iconF7="bubble_left_bubble_right"
              tabLink="#view-message-master"
              onClick={() => this.navMessage('account', 'admin', 'account')}
            />
          </NavRight> */}
        </Navbar>

        <Tabs animated style={{ overflowY: "scroll" }}>
          {this.state.showTab == "business" ? (
            <Tab id="tab-business">
              <Block style={{ paddingBottom: "40px" }}>
                <Card style={{ margin: "auto" }}>
                  <CardHeader
                    className="no-border bg-color-theme bg-image-pattern"
                    style={{
                      backgroundSize: "50%",
                      height: "200px",
                    }}
                  >
                    <img
                      src="static/logo.svg"
                      style={{
                        width: "128px",
                        height: "128px",
                        margin: "auto",
                      }}
                    />
                  </CardHeader>
                  <CardContent>
                    <h6 style={{ margin: 0, textAlign: "center" }}>
                      Business Easychaw
                    </h6>
                  </CardContent>
                </Card>

                <Link
                  onClick={() => this.$f7.methods.navAccount("merchant")}
                  style={{
                    display: "block",
                    color: "#444444",
                  }}
                >
                  <Card style={{ margin: "15pt auto" }}>
                    <CardContent padding={false}>
                      <Row noGap={true}>
                        <Col
                          width="5"
                          className="bg-image-pattern"
                          style={{
                            height: "100px",
                            backgroundSize: "350%",
                            backgroundColor: "#a1e8cc",
                            borderTopLeftRadius: "4px",
                            borderBottomLeftRadius: "4px",
                          }}
                        />
                        <Col width="60" large="65">
                          <Block>
                            <Row>
                              <Col width="100">
                                <h2 style={{ fontFamily: "Italiana" }}>
                                  Food Merchants
                                </h2>
                              </Col>
                              <Col width="100">
                                <small style={{ color: "#8e8e93" }}>
                                  continue <Icon f7="arrow_right" />
                                </small>
                              </Col>
                            </Row>
                          </Block>
                        </Col>
                        <Col
                          width="35"
                          large="30"
                          style={{
                            backgroundImage:
                              "url(./static/merchant.png), linear-gradient(0deg, rgba(223,171,1,1) 0%, rgba(254,202,32,1) 35%, rgba(254,212,72,1) 100%)",
                            height: "100px",
                            backgroundSize: "cover",
                            backgroundPosition: "top center",
                            backgroundColor: "#fed448",
                            backgroundRepeat: "no-repeat",
                            borderTopRightRadius: "4px",
                            borderBottomRightRadius: "4px",
                          }}
                        />
                      </Row>
                    </CardContent>
                  </Card>
                </Link>

                <Link
                  onClick={() => this.$f7.methods.navAccount("delivery")}
                  style={{
                    display: "block",
                    color: "#444444",
                  }}
                >
                  <Card style={{ margin: "15pt auto" }}>
                    <CardContent padding={false}>
                      <Row noGap={true}>
                        <Col
                          width="5"
                          className="bg-image-pattern"
                          style={{
                            height: "100px",
                            backgroundSize: "350%",
                            backgroundColor: "#a1e8cc",
                            borderTopLeftRadius: "4px",
                            borderBottomLeftRadius: "4px",
                          }}
                        />
                        <Col width="60" large="65">
                          <Block>
                            <Row>
                              <Col width="100">
                                <h2 style={{ fontFamily: "Italiana" }}>
                                  Delivery Agents
                                </h2>
                              </Col>
                              <Col width="100">
                                <small style={{ color: "#8e8e93" }}>
                                  continue <Icon f7="arrow_right" />
                                </small>
                              </Col>
                            </Row>
                          </Block>
                        </Col>
                        <Col
                          width="35"
                          large="30"
                          style={{
                            backgroundImage:
                              "url(./static/easybike.png), url(./static/van.png), linear-gradient(0deg, rgba(223,171,1,1) 0%, rgba(254,202,32,1) 35%, rgba(254,212,72,1) 100%)",
                            height: "100px",
                            backgroundSize: "contain",
                            backgroundPosition:
                              "bottom left, top right, top center",
                            backgroundColor: "#fed448",
                            backgroundRepeat: "no-repeat",
                            borderTopRightRadius: "4px",
                            borderBottomRightRadius: "4px",
                          }}
                        />
                      </Row>
                    </CardContent>
                  </Card>
                </Link>

                <Link
                  onClick={() => this.$f7.methods.navAccount("partners")}
                  style={{
                    display: "block",
                    color: "#444444",
                  }}
                >
                  <Card style={{ margin: "15pt auto" }}>
                    <CardContent padding={false}>
                      <Row noGap={true}>
                        <Col
                          width="5"
                          className="bg-image-pattern"
                          style={{
                            height: "100px",
                            backgroundSize: "350%",
                            backgroundColor: "#a1e8cc",
                            borderTopLeftRadius: "4px",
                            borderBottomLeftRadius: "4px",
                          }}
                        />
                        <Col width="60" large="65">
                          <Block style={{ paddingRight: 0 }}>
                            <Row>
                              <Col width="100">
                                <h2 style={{ fontFamily: "Italiana" }}>
                                  Easychaw Agents
                                </h2>
                              </Col>
                              <Col width="100">
                                <small style={{ color: "#8e8e93" }}>
                                  continue <Icon f7="arrow_right" />
                                </small>
                              </Col>
                            </Row>
                          </Block>
                        </Col>
                        <Col
                          width="35"
                          large="30"
                          style={{
                            backgroundImage:
                              "url(./static/agent.png), linear-gradient(0deg, rgba(223,171,1,1) 0%, rgba(254,202,32,1) 35%, rgba(254,212,72,1) 100%)",
                            height: "100px",
                            backgroundSize: "contain",
                            backgroundPosition: "top center",
                            backgroundColor: "#fed448",
                            backgroundRepeat: "no-repeat",
                            borderTopRightRadius: "4px",
                            borderBottomRightRadius: "4px",
                          }}
                        />
                      </Row>
                    </CardContent>
                  </Card>
                </Link>
              </Block>
            </Tab>
          ) : null}

          {this.state.showTab == "profile" ? (
            <Tab id="tab-profile">
              <Block style={{ paddingBottom: "32px" }}>
                <Card style={{ margin: "auto" }}>
                  <CardHeader
                    className="no-border bg-color-theme bg-image-pattern"
                    style={{
                      backgroundSize: "50%",
                      height: "200px",
                    }}
                  >
                    <img
                      src="static/logo.svg"
                      style={{
                        width: "128px",
                        height: "128px",
                        margin: "auto",
                      }}
                    />
                  </CardHeader>
                  <CardContent>
                    <h4 style={{ margin: 0 }}>{this.props.profile.fullName}</h4>
                    <small style={{ margin: 0 }}>
                      Profile last updated{" "}
                      {moment(this.props.profile.lastUpdated).fromNow()}
                    </small>
                  </CardContent>
                </Card>

                <Card style={{ margin: "auto", marginTop: "20pt" }}>
                  <CardHeader>
                    <div className="data-table-title">Profile Dashboard</div>
                  </CardHeader>
                  <CardContent>
                    <Row>
                      <Col width="50">
                        <Button
                          outline
                          href="/profile/1/"
                          iconF7="purchased_circle"
                        >
                          &nbsp;&nbsp;&nbsp;History
                        </Button>
                      </Col>
                      <Col width="50">
                        <Button outline href="/profile/2/" iconF7="creditcard">
                          &nbsp;&nbsp;&nbsp;Wallet
                        </Button>
                      </Col>
                    </Row>
                  </CardContent>
                  {this.props.profile.role == "Admin" ? (
                    <CardFooter>
                      <Button
                        fill
                        href="/admin/"
                        className="button-fill-red"
                        style={{
                          width: "100%",
                        }}
                      >
                        Admin Dashboard
                      </Button>
                    </CardFooter>
                  ) : null}
                  {this.props.profile.role == "Support" ? (
                    <CardFooter>
                      <Button
                        fill
                        href="/support/"
                        className="button-fill-red"
                        style={{
                          width: "100%",
                        }}
                      >
                        Support Dashboard
                      </Button>
                    </CardFooter>
                  ) : null}
                </Card>

                <Row style={{ marginTop: "20pt" }}>
                  <Col width="80">
                    <h4 style={{ margin: 0 }}>Your Profile</h4>
                    <small style={{ margin: 0 }}>
                      Please ensure your profile is up to date
                    </small>
                  </Col>
                  <Col width="20">
                    <div
                      className="searchFilterBtn"
                      style={{
                        backgroundColor: this.state.edit
                          ? "var(--f7-theme-color-shade)"
                          : "",
                      }}
                      onClick={() =>
                        this.setState({ ...this.state, edit: !this.state.edit })
                      }
                    >
                      <Link iconF7="pencil_ellipsis_rectangle"></Link>
                    </div>
                  </Col>
                </Row>

                <Card style={{ margin: "20pt auto" }}>
                  <CardContent>
                    <List noHairlinesMd>
                      <ListInput
                        label="Full Name"
                        type="text"
                        placeholder="Full name"
                        validate
                        required
                        value={this.state.profile.fullName}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            profile: {
                              ...this.state.profile,
                              fullName: e.target.value,
                            },
                          })
                        }
                        disabled={!this.state.edit}
                      >
                        <Icon
                          f7="person"
                          slot="media"
                          style={{
                            color: this.state.edit
                              ? "var(--f7-theme-color-shade)"
                              : "",
                          }}
                        />
                      </ListInput>

                      <ListInput
                        label="Phone number"
                        type="number"
                        placeholder="eg: 0703xxxxxxx"
                        disabled={!this.state.edit}
                        validate
                        value={this.state.profile.phoneNumber}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            profile: {
                              ...this.state.profile,
                              phoneNumber: e.target.value,
                            },
                          })
                        }
                      >
                        <Icon
                          f7="phone"
                          slot="media"
                          style={{
                            color: this.state.edit
                              ? "var(--f7-theme-color-shade)"
                              : "",
                          }}
                        />
                      </ListInput>

                      <ListInput
                        label="Email"
                        type="email"
                        placeholder="name@domain.com"
                        disabled={!this.state.edit}
                        validate
                        required
                        value={this.state.profile.email}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            profile: {
                              ...this.state.profile,
                              email: e.target.value,
                            },
                          })
                        }
                      >
                        <Icon f7="envelope" slot="media" />
                      </ListInput>

                      <ListInput
                        label="Home address"
                        type="text"
                        placeholder="eg: Apt No., Street, City, State"
                        disabled={!this.state.edit}
                        validate
                        id="homeAddress"
                        required
                        value={this.state.profile.homeLocation.address}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            profile: {
                              ...this.state.profile,
                              homeLocation: {
                                ...this.state.profile.homeLocation,
                                address: e.target.value,
                              },
                            },
                          })
                        }
                      >
                        <Icon
                          f7="house"
                          slot="media"
                          style={{
                            color: this.state.edit
                              ? "var(--f7-theme-color-shade)"
                              : "",
                          }}
                        />
                      </ListInput>
                      <ListInput
                        label="Work address"
                        type="text"
                        placeholder="eg: Apt No., Street, City, State"
                        disabled={!this.state.edit}
                        validate
                        id="workAddress"
                        required
                        value={this.state.profile.workLocation.address}
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            profile: {
                              ...this.state.profile,
                              workLocation: {
                                ...this.state.profile.workLocation,
                                address: e.target.value,
                              },
                            },
                          })
                        }
                      >
                        <Icon
                          f7="briefcase"
                          slot="media"
                          style={{
                            color: this.state.edit
                              ? "var(--f7-theme-color-shade)"
                              : "",
                          }}
                        />
                      </ListInput>
                    </List>
                  </CardContent>

                  <CardFooter
                    style={{ display: this.state.edit ? "block" : "none" }}
                  >
                    <Button
                      round
                      fill
                      className="button button-fill-blue"
                      style={{
                        width: "100%",
                      }}
                      disabled={
                        !this.state.edit ||
                        this.state.updateProfileButton !== "Save Profile"
                      }
                      onClick={this.updateProfile.bind(this)}
                    >
                      {this.state.updateProfileButton}
                    </Button>
                  </CardFooter>
                </Card>
              </Block>
            </Tab>
          ) : null}

          {this.state.showTab == "merchant" ? (
            <Tab id="tab-merchant">
              {/* <MerchantAndDeliverySkeleton /> */}
              {this.props.loadingDoc && !this.props.merchants ? (
                <Block className="text-align-center">
                  {/* <MerchantAndDeliverySkeleton /> */}
                  <Preloader></Preloader>
                </Block>
              ) : !this.props.profile.isEmpty &&
                this.props.profile.merchant &&
                this.props.merchants &&
                this.props.merchants[this.props.auth.uid] ? (
                // show this block if user is already a merchant
                <Block style={{ paddingBottom: "32px" }}>
                  <Card style={{ margin: "auto" }}>
                    <CardHeader
                      className="no-border"
                      style={{
                        height: "200px",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundImage:
                          "url(" +
                          this.props.merchants[this.props.auth.uid]
                            .businessProfile.images.logo.URL +
                          ")",
                      }}
                    ></CardHeader>
                    <CardContent>
                      <h3 style={{ textAlign: "center", margin: 0 }}>
                        {
                          this.props.merchants[this.props.auth.uid]
                            .businessProfile.name
                        }
                      </h3>
                      <p style={{ textAlign: "center", margin: 0 }}>
                        {
                          this.props.merchants[this.props.auth.uid]
                            .businessProfile.slogan
                        }
                      </p>
                    </CardContent>
                  </Card>

                  {this.props.merchants[this.props.auth.uid].approved &&
                  this.props.merchants[this.props.auth.uid].accountStatus !==
                    "Suspended" ? (
                    <Card style={{ margin: "10pt auto" }}>
                      <CardHeader>Dashboard</CardHeader>
                      <CardContent>
                        <Button fill href="/merchant/">
                          Merchant Dashboard
                        </Button>
                      </CardContent>
                    </Card>
                  ) : this.props.merchants[this.props.auth.uid]
                      .accountStatus === "Pending" ? (
                    <Card style={{ margin: "20pt auto" }}>
                      <CardHeader className="no-border">
                        Account Status
                      </CardHeader>
                      <CardContent style={{ paddingTop: 0 }}>
                        <Block className="pab">
                          <Row>
                            <Col>
                              <p>Application Pending &nbsp;&nbsp;&nbsp;</p>
                            </Col>
                            <Col>
                              <Link
                                className="pal"
                                tabLink="#view-message-master"
                                onClick={() =>
                                  this.navMessage("account", "admin", "account")
                                }
                              >
                                Contact Admin
                              </Link>
                            </Col>
                          </Row>

                          <Row className="pat">
                            <Col>
                              <p style={{ margin: "0", color: " #9E9E9E" }}>
                                Please contact Admin after 24 hours if account
                                is still pending.
                              </p>
                            </Col>
                          </Row>
                        </Block>
                      </CardContent>
                    </Card>
                  ) : this.props.merchants[this.props.auth.uid]
                      .accountStatus === "Declined" ? (
                    <Card style={{ margin: "20pt auto" }}>
                      <CardHeader className="no-border">
                        Account Status
                      </CardHeader>
                      <CardContent style={{ paddingTop: 0 }}>
                        <Block className="sdab">
                          <Row>
                            <Col>
                              <p>Application Declined &nbsp;&nbsp;&nbsp;</p>
                            </Col>
                            <Col>
                              <Link className="sdal" href="/decline/1/">
                                Reasons
                              </Link>
                            </Col>
                          </Row>
                        </Block>
                      </CardContent>
                    </Card>
                  ) : (
                    <Card style={{ margin: "20pt auto" }}>
                      <CardHeader className="no-border">
                        Account Status
                      </CardHeader>
                      <CardContent style={{ paddingTop: 0 }}>
                        <Block className="sdab">
                          <Row>
                            <Col>
                              <p>Account Suspended &nbsp;&nbsp;&nbsp;</p>
                            </Col>
                            <Col>
                              <Link
                                className="sdal"
                                tabLink="#view-message-master"
                                onClick={() =>
                                  this.navMessage("account", "admin", "account")
                                }
                              >
                                Contact Admin
                              </Link>
                            </Col>
                          </Row>
                        </Block>
                      </CardContent>
                    </Card>
                  )}

                  <Row style={{ marginTop: "20pt" }}>
                    <Col width="80">
                      <h4 style={{ margin: 0 }}>Merchant Profile</h4>
                      <small style={{ margin: 0 }}>
                        Please ensure details are up to date
                      </small>
                    </Col>
                    <Col width="20">
                      <div
                        className="searchFilterBtn"
                        style={{
                          backgroundColor: this.state.merchantEdit
                            ? "var(--f7-theme-color-shade)"
                            : "",
                        }}
                      >
                        <Link
                          iconF7="pencil_ellipsis_rectangle"
                          onClick={() => {
                            this.setState((prevState) => {
                              return {
                                ...this.state,
                                merchantEdit: !prevState.merchantEdit,
                                displayImageSrc: !prevState.merchantEdit
                                  ? this.props.merchants[this.props.auth.uid]
                                      .businessProfile.images.logo.URL
                                  : "",
                                image: !prevState.merchantEdit ? "" : null,
                                which: !prevState.merchantEdit
                                  ? "merchant"
                                  : "",
                              };
                            });
                          }}
                        ></Link>
                      </div>
                    </Col>
                  </Row>

                  <Card style={{ margin: "20pt auto" }}>
                    <CardContent>
                      <List noHairlinesMd>
                        <ListInput
                          label="Business Name"
                          type="text"
                          placeholder="Business name"
                          disabled={!this.state.merchantEdit}
                          value={this.state.merchant.name}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              merchant: {
                                ...this.state.merchant,
                                name: e.target.value,
                              },
                            })
                          }
                        >
                          <Icon
                            f7="briefcase"
                            slot="media"
                            style={{
                              color: this.state.merchantEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>

                        <ListInput
                          label="Business Phone number"
                          type="text"
                          placeholder="eg: 0703xxxxxxx"
                          disabled={!this.state.merchantEdit}
                          value={this.state.merchant.phone}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              merchant: {
                                ...this.state.merchant,
                                phone: e.target.value,
                              },
                            })
                          }
                        >
                          <Icon
                            f7="phone"
                            slot="media"
                            style={{
                              color: this.state.merchantEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>

                        <ListInput
                          label="Business email"
                          type="email"
                          placeholder="info@domain.com"
                          disabled={!this.state.merchantEdit}
                          value={this.state.merchant.email}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              merchant: {
                                ...this.state.merchant,
                                email: e.target.value,
                              },
                            })
                          }
                        >
                          <Icon
                            f7="envelope"
                            slot="media"
                            style={{
                              color: this.state.merchantEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>

                        <ListInput
                          label="Business address"
                          type="text"
                          placeholder="eg: Apt No., Street, City, State"
                          id="merchant_business_address"
                          disabled={!this.state.merchantEdit}
                          value={this.state.merchant.address}
                          onBlur={(e) => {
                            if (e.target.value.trim() === "") {
                              return toast(this.$f7.toast, {
                                text: `Please enter a valid address`,
                                position: "bottom",
                                horizontalPosition: "center",
                                closeButton: true,
                                cssClass: "custom-toast",
                                closeTimeout: 4000,
                              });
                            }
                          }}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              [this.state.which]: {
                                ...this.state[this.state.which],

                                address: e.target.value,
                              },
                            })
                          }
                        >
                          <Icon
                            f7="map_pin_ellipse"
                            slot="media"
                            style={{
                              color: this.state.merchantEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>
                        <ListInput
                          label="Slogan"
                          type="text"
                          placeholder="Please enter slogan here"
                          disabled={!this.state.merchantEdit}
                          value={this.state.merchant.slogan}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              [this.state.which]: {
                                ...this.state[this.state.which],

                                slogan: e.target.value,
                              },
                            })
                          }
                        >
                          <Icon
                            f7="pencil_outline"
                            slot="media"
                            style={{
                              color: this.state.merchantEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>
                        <ListInput
                          label="State"
                          type="select"
                          placeholder="Please select state"
                          info="Select state from dropdown"
                          disabled={!this.state.merchantEdit}
                          required
                          value={this.state.merchant.state}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              [this.state.which]: {
                                ...this.state[this.state.which],

                                state: e.target.value,
                              },
                            })
                          }
                        >
                          <option></option>
                          {[
                            ...new Set(
                              cities
                                .filter(
                                  (cityInfo) =>
                                    cityInfo.country ===
                                    this.props.merchants[this.props.auth.uid]
                                      .businessProfile.country,
                                )
                                .map((cityInfo) => cityInfo.admin_name),
                            ),
                          ]
                            .sort()
                            .map((stateName, i) => (
                              <option key={i} value={stateName}>
                                {stateName}
                              </option>
                            ))}
                          <Icon
                            f7="globe"
                            slot="media"
                            style={{
                              color: this.state.merchantEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>
                        <ListInput
                          label="City"
                          type="select"
                          placeholder="Please select city"
                          info="Select state from dropdown"
                          required
                          disabled={
                            !this.state.merchantEdit ||
                            this.state.merchant.state.trim() === ""
                          }
                          value={this.state.merchant.city}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              [this.state.which]: {
                                ...this.state[this.state.which],

                                city: e.target.value,
                              },
                            })
                          }
                        >
                          <option></option>
                          {this.state.merchant.state &&
                            [
                              ...new Set(
                                cities
                                  .filter(
                                    (cityInfo) =>
                                      cityInfo.country ===
                                        this.props.merchants[
                                          this.props.auth.uid
                                        ].businessProfile.country &&
                                      cityInfo.admin_name ===
                                        this.state.merchant.state,
                                  )
                                  .map((cityInfo) => cityInfo.city),
                              ),
                            ]
                              .sort()
                              .map((cityName, i) => (
                                <option key={i} value={cityName}>
                                  {cityName}
                                </option>
                              ))}
                          <Icon
                            f7="globe"
                            slot="media"
                            style={{
                              color: this.state.merchantEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>
                      </List>
                      <Row
                        style={{
                          display: this.state.merchantEdit ? "block" : "none",
                          marginTop: "20pt",
                        }}
                      >
                        <Col width="100">
                          <List mediaList>
                            <ListInput
                              className="custom-file-input"
                              label="Buisness Logo"
                              type="file"
                              info="Formats png|jpg|jpeg"
                              onChange={(e) => {
                                const reader = new FileReader();
                                if (reader) {
                                  reader.onload = (e) => {
                                    this.setState({
                                      ...this.state,
                                      displayImageSrc: e.target.result,
                                    });
                                  };
                                  reader.readAsDataURL(e.target.files[0]);
                                }
                                this.setState({
                                  ...this.state,

                                  image: e.target.files[0],
                                });
                              }}
                            >
                              <img
                                slot="media"
                                src={this.state.displayImageSrc}
                                style={{
                                  width: "75px",
                                  height: "75px",
                                  marginLeft: "-13px",
                                  objectFit: "cover",
                                }}
                              />
                            </ListInput>
                          </List>
                        </Col>
                        <Col width="100">
                          <BlockTitle style={{ marginLeft: "0px" }}>
                            Please select business location
                          </BlockTitle>
                          <div
                            id="merchantMap"
                            className="business-map"
                            style={{
                              height: "200px",
                              border: "2px solid #ddd",
                              borderRadius: "6px",
                              marginLeft: "0px",
                            }}
                          >
                            {this.state.merchantEdit && (
                              <GoogleMapReact
                                bootstrapURLKeys={{
                                  key: "AIzaSyBUQs-C3DV8iZ_NYSdjHN--g50yMETXXMY",
                                  libraries: ["places"],
                                }}
                                defaultCenter={{
                                  lat: 59.95,
                                  lng: 30.33,
                                }}
                                center={
                                  this.state[this.state.which].geoLoc.lat !==
                                    "" &&
                                  this.state[this.state.which].geoLoc.lng !== ""
                                    ? this.state[this.state.which].geoLoc
                                    : { lat: 59.95, lng: 30.33 }
                                }
                                defaultZoom={18}
                                layerTypes={["TrafficLayer", "TransitLayer"]}
                                options={{
                                  mapTypeControl: true,
                                  mapTypeControlOptions: {
                                    mapTypeIds: [
                                      "roadmap",
                                      "terrain",
                                      "satellite",
                                    ],
                                  },
                                }}
                                onClick={this.mapClicked.bind(this)}
                                onGoogleApiLoaded={this.addAutoComplete.bind(
                                  this,
                                )}
                                yesIWantToUseGoogleMapApiInternals
                              >
                                {this.state[this.state.which].geoLoc.lat !==
                                  "" &&
                                  this.state[this.state.which].geoLoc.lng !==
                                    "" && (
                                    <Marker
                                      lat={
                                        this.state[this.state.which].geoLoc.lat
                                      }
                                      lng={
                                        this.state[this.state.which].geoLoc.lng
                                      }
                                    />
                                  )}
                              </GoogleMapReact>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </CardContent>
                    <CardFooter
                      style={{
                        display: this.state.merchantEdit ? "block" : "none",
                      }}
                    >
                      <Button
                        round
                        fill
                        className="button button-fill-blue"
                        style={{
                          width: "100%",
                        }}
                        disabled={
                          !this.state.merchantEdit ||
                          this.state.merchant.address.trim() === "" ||
                          this.state.updateMerchantButton !== "Save"
                        }
                        onClick={this.updateMerchant.bind(this)}
                      >
                        {this.state.updateMerchantButton}
                      </Button>
                    </CardFooter>
                  </Card>
                </Block>
              ) : (
                // show this block if user is not a merchant
                <Block style={{ paddingBottom: "32px" }}>
                  <Card style={{ margin: "auto" }}>
                    <CardHeader
                      className="no-border"
                      style={{ height: "200px" }}
                    >
                      <Row style={{ width: "100%" }}>
                        <Col width="100">
                          <div style={{ width: "160px", margin: "auto" }}>
                            {" "}
                            <PrimaryLogo />{" "}
                          </div>
                        </Col>
                        <Col width="100">
                          <div
                            style={{
                              width: "160px",
                              margin: "10pt auto 0 auto",
                            }}
                          >
                            {" "}
                            <MerchantSvg />{" "}
                          </div>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardContent>
                      <h3 style={{ textAlign: "center", margin: 0 }}>
                        Merchant
                      </h3>
                    </CardContent>
                  </Card>

                  <Row style={{ marginTop: "20pt" }}>
                    <Col width="100">
                      <h4 style={{ margin: 0 }}>Merchant</h4>
                      <small style={{ margin: 0 }}>
                        Please sign up to become a merchant
                      </small>
                    </Col>
                  </Row>

                  <Card style={{ margin: "20pt auto" }}>
                    <CardHeader className="no-border">Features</CardHeader>
                    <CardContent>
                      <List noHairlinesMd>
                        {this.state.featuresMerchant.map((value, index) => (
                          <ListItem title={value} key={index}>
                            <Icon f7="checkmark_alt_circle" slot="media" />
                          </ListItem>
                        ))}
                      </List>
                    </CardContent>
                  </Card>
                  <Button round fill href="/business-registration/1/">
                    Merchant Sign Up
                  </Button>
                </Block>
              )}
            </Tab>
          ) : null}

          {this.state.showTab == "delivery" ? (
            <Tab id="tab-delivery">
              {this.props.loadingDoc && !this.props.delivery ? (
                <Block className="text-align-center">
                  <Preloader></Preloader>
                </Block>
              ) : !this.props.profile.isEmpty &&
                this.props.profile.deliveryServices &&
                this.props.delivery &&
                this.props.delivery[this.props.auth.uid] ? (
                // show this block if user is already an agent
                <Block style={{ paddingBottom: "32px" }}>
                  <Card style={{ margin: "auto" }}>
                    <CardHeader
                      className="no-border"
                      style={{
                        height: "200px",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundImage:
                          "url(" +
                          this.props.delivery[this.props.auth.uid]
                            .businessProfile.images.logo.URL +
                          ")",
                      }}
                    ></CardHeader>
                    <CardContent>
                      <h3 style={{ textAlign: "center", margin: 0 }}>
                        {
                          this.props.delivery[this.props.auth.uid]
                            .businessProfile.name
                        }
                      </h3>
                      <p style={{ textAlign: "center", margin: 0 }}>
                        {
                          this.props.delivery[this.props.auth.uid]
                            .businessProfile.slogan
                        }
                      </p>
                    </CardContent>
                  </Card>

                  {this.props.delivery[this.props.auth.uid].approved &&
                  this.props.delivery[this.props.auth.uid].accountStatus !==
                    "Suspended" ? (
                    <Card style={{ margin: "20pt auto" }}>
                      <CardHeader>Dashboard</CardHeader>
                      <CardContent>
                        <Button fill href="/delivery/">
                          Delivery Agent Dashboard
                        </Button>
                      </CardContent>
                    </Card>
                  ) : this.props.delivery[this.props.auth.uid].accountStatus ===
                    "Pending" ? (
                    <Card style={{ margin: "20pt auto" }}>
                      <CardHeader className="no-border">
                        Account Status
                      </CardHeader>
                      <CardContent style={{ paddingTop: 0 }}>
                        <Block className="pab">
                          <Row>
                            <Col>
                              <p>Application Pending &nbsp;&nbsp;&nbsp;</p>
                            </Col>
                            <Col>
                              <Link
                                className="pal"
                                tabLink="#view-message-master"
                                onClick={() =>
                                  this.navMessage("account", "admin", "account")
                                }
                              >
                                Contact Admin
                              </Link>
                            </Col>
                          </Row>
                          <Row className="pat">
                            <Col>
                              <p style={{ margin: "0", color: " #9E9E9E" }}>
                                Please contact Admin after 24 hours if account
                                is still pending.
                              </p>
                            </Col>
                          </Row>
                        </Block>
                      </CardContent>
                    </Card>
                  ) : this.props.delivery[this.props.auth.uid].accountStatus ===
                    "Declined" ? (
                    <Card style={{ margin: "20pt auto" }}>
                      <CardHeader className="no-border">
                        Account Status
                      </CardHeader>
                      <CardContent style={{ paddingTop: 0 }}>
                        <Block className="sdab">
                          <Row>
                            <Col>
                              <p>Application Declined &nbsp;&nbsp;&nbsp;</p>
                            </Col>
                            <Col>
                              <Link className="sdal" href="/decline/2/">
                                Reasons
                              </Link>
                            </Col>
                          </Row>
                        </Block>
                      </CardContent>
                    </Card>
                  ) : (
                    <Card style={{ margin: "20pt auto" }}>
                      <CardHeader className="no-border">
                        Account Status
                      </CardHeader>
                      <CardContent style={{ paddingTop: 0 }}>
                        <Block className="sdab">
                          <Row>
                            <Col>
                              <p>Account Suspended &nbsp;&nbsp;&nbsp;</p>
                            </Col>
                            <Col>
                              <Link
                                className="sdal"
                                tabLink="#view-message-master"
                                onClick={() =>
                                  this.navMessage("account", "admin", "account")
                                }
                              >
                                Contact Admin
                              </Link>
                            </Col>
                          </Row>
                        </Block>
                      </CardContent>
                    </Card>
                  )}

                  <Row style={{ marginTop: "20pt" }}>
                    <Col width="80">
                      <h4 style={{ margin: 0 }}>Delivery Agent Profile</h4>
                      <small style={{ margin: 0 }}>
                        Please ensure details are up to date
                      </small>
                    </Col>
                    <Col width="20">
                      <div
                        className="searchFilterBtn"
                        style={{
                          backgroundColor: this.state.deliveryEdit
                            ? "var(--f7-theme-color-shade)"
                            : "",
                        }}
                      >
                        <Link
                          iconF7="pencil_ellipsis_rectangle"
                          onClick={() => {
                            this.setState((prevState) => {
                              return {
                                ...this.state,
                                deliveryEdit: !prevState.deliveryEdit,
                                displayImageSrc: !prevState.deliveryEdit
                                  ? this.props.delivery[this.props.auth.uid]
                                      .businessProfile.images.logo.URL
                                  : "",
                                image: !prevState.deliveryEdit ? "" : null,
                                which: !prevState.deliveryEdit
                                  ? "delivery"
                                  : "",
                              };
                            });
                          }}
                        ></Link>
                      </div>
                    </Col>
                  </Row>

                  <Card style={{ margin: "20pt auto" }}>
                    <CardContent>
                      <List>
                        <ListInput
                          label="Business Name"
                          type="text"
                          placeholder="Business name"
                          disabled={!this.state.deliveryEdit}
                          value={this.state.delivery.name}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              delivery: {
                                ...this.state.delivery,
                                name: e.target.value,
                              },
                            })
                          }
                        >
                          <Icon
                            f7="briefcase"
                            slot="media"
                            style={{
                              color: this.state.deliveryEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>
                        <ListInput
                          label="Business Phone number"
                          type="text"
                          placeholder="eg: 0703xxxxxxx"
                          disabled={!this.state.deliveryEdit}
                          value={this.state.delivery.phone}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              delivery: {
                                ...this.state.delivery,
                                phone: e.target.value,
                              },
                            })
                          }
                        >
                          <Icon
                            f7="phone"
                            slot="media"
                            style={{
                              color: this.state.deliveryEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>

                        <ListInput
                          label="Business email"
                          type="email"
                          placeholder="info@domain.com"
                          disabled={!this.state.deliveryEdit}
                          value={this.state.delivery.email}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              delivery: {
                                ...this.state.delivery,
                                email: e.target.value,
                              },
                            })
                          }
                        >
                          <Icon
                            f7="envelope"
                            slot="media"
                            style={{
                              color: this.state.deliveryEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>

                        <ListInput
                          label="Business address"
                          type="text"
                          placeholder="eg: Apt No., Street, City, State"
                          disabled={!this.state.deliveryEdit}
                          value={this.state.delivery.address}
                          id="delivery_business_address"
                          onBlur={(e) => {
                            if (e.target.value.trim() === "") {
                              return toast(this.$f7.toast, {
                                text: `Please enter a valid address`,
                                position: "bottom",
                                horizontalPosition: "center",
                                closeButton: true,
                                cssClass: "custom-toast",
                                closeTimeout: 4000,
                              });
                            }
                          }}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              [this.state.which]: {
                                ...this.state[this.state.which],

                                address: e.target.value,
                              },
                            })
                          }
                        >
                          <Icon
                            f7="map_pin_ellipse"
                            slot="media"
                            style={{
                              color: this.state.deliveryEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>
                        <ListInput
                          label="Slogan"
                          type="text"
                          placeholder="Please enter slogan here"
                          disabled={!this.state.deliveryEdit}
                          value={this.state.delivery.slogan}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              [this.state.which]: {
                                ...this.state[this.state.which],

                                slogan: e.target.value,
                              },
                            })
                          }
                        >
                          <Icon
                            f7="pencil_outline"
                            slot="media"
                            style={{
                              color: this.state.deliveryEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>
                        <ListInput
                          label="Logistic type"
                          type="select"
                          placeholder="Please select type"
                          info="Select automobile from dropdown"
                          disabled={!this.state.deliveryEdit}
                          required
                          value={this.state.delivery.category}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              [this.state.which]: {
                                ...this.state[this.state.which],

                                category: e.target.value,
                              },
                            })
                          }
                        >
                          <option value="Bikes">Bikes</option>
                          <option value="Cars">Cars</option>
                          <option value="Multiple">Multiple</option>

                          <Icon
                            f7="layers_alt"
                            slot="media"
                            style={{
                              color: this.state.deliveryEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>
                        <ListInput
                          label="State"
                          type="select"
                          placeholder="Please select state"
                          info="Select state from dropdown"
                          disabled={!this.state.deliveryEdit}
                          required
                          value={this.state.delivery.state}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              [this.state.which]: {
                                ...this.state[this.state.which],

                                state: e.target.value,
                              },
                            })
                          }
                        >
                          <option></option>
                          {[
                            ...new Set(
                              cities
                                .filter(
                                  (cityInfo) =>
                                    cityInfo.country ===
                                    this.props.delivery[this.props.auth.uid]
                                      .businessProfile.country,
                                )
                                .map((cityInfo) => cityInfo.admin_name),
                            ),
                          ]
                            .sort()
                            .map((stateName, i) => (
                              <option key={i} value={stateName}>
                                {stateName}
                              </option>
                            ))}
                          <Icon
                            f7="globe"
                            slot="media"
                            style={{
                              color: this.state.deliveryEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>
                        <ListInput
                          label="City"
                          type="select"
                          placeholder="Please select city"
                          info="Select state from dropdown"
                          required
                          disabled={
                            !this.state.deliveryEdit ||
                            this.state.delivery.state.trim() === ""
                          }
                          value={this.state.delivery.city}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              [this.state.which]: {
                                ...this.state[this.state.which],

                                city: e.target.value,
                              },
                            })
                          }
                        >
                          <option></option>
                          {this.state.delivery.state &&
                            [
                              ...new Set(
                                cities
                                  .filter(
                                    (cityInfo) =>
                                      cityInfo.country ===
                                        this.props.delivery[this.props.auth.uid]
                                          .businessProfile.country &&
                                      cityInfo.admin_name ===
                                        this.state.delivery.state,
                                  )
                                  .map((cityInfo) => cityInfo.city),
                              ),
                            ]
                              .sort()
                              .map((cityName, i) => (
                                <option key={i} value={cityName}>
                                  {cityName}
                                </option>
                              ))}
                          <Icon
                            f7="globe"
                            slot="media"
                            style={{
                              color: this.state.deliveryEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>
                      </List>
                      <Row
                        style={{
                          display: this.state.deliveryEdit ? "block" : "none",
                          marginTop: "20pt",
                        }}
                      >
                        <Col width="100">
                          <List mediaList>
                            <ListInput
                              className="custom-file-input"
                              label="Buisness Logo"
                              type="file"
                              info="Formats png|jpg|jpeg"
                              onChange={(e) => {
                                const reader = new FileReader();
                                if (reader) {
                                  reader.onload = (e) => {
                                    this.setState({
                                      ...this.state,
                                      displayImageSrc: e.target.result,
                                    });
                                  };
                                  reader.readAsDataURL(e.target.files[0]);
                                }
                                this.setState({
                                  ...this.state,
                                  image: e.target.files[0],
                                });
                              }}
                            >
                              <img
                                slot="media"
                                src={this.state.displayImageSrc}
                                style={{
                                  width: "75px",
                                  height: "75px",
                                  marginLeft: "-13px",
                                  objectFit: "cover",
                                }}
                              />
                            </ListInput>
                          </List>
                        </Col>

                        <Col width="100">
                          <BlockTitle style={{ marginLeft: "0px" }}>
                            Please select business location
                          </BlockTitle>
                          <div
                            id="deliveryMap"
                            className="business-map"
                            style={{
                              height: "200px",
                              border: "2px solid #ddd",
                              borderRadius: "6px",
                              marginLeft: "0px",
                            }}
                          >
                            {this.state.deliveryEdit && (
                              <GoogleMapReact
                                bootstrapURLKeys={{
                                  key: "AIzaSyBUQs-C3DV8iZ_NYSdjHN--g50yMETXXMY",
                                  libraries: ["places"],
                                }}
                                defaultCenter={{
                                  lat: 59.95,
                                  lng: 30.33,
                                }}
                                center={
                                  this.state[this.state.which].geoLoc.lat !==
                                    "" &&
                                  this.state[this.state.which].geoLoc.lng !== ""
                                    ? this.state[this.state.which].geoLoc
                                    : { lat: 59.95, lng: 30.33 }
                                }
                                defaultZoom={18}
                                layerTypes={["TrafficLayer", "TransitLayer"]}
                                options={{
                                  mapTypeControl: true,
                                  mapTypeControlOptions: {
                                    mapTypeIds: [
                                      "roadmap",
                                      "terrain",
                                      "satellite",
                                    ],
                                  },
                                }}
                                onClick={this.mapClicked.bind(this)}
                                onGoogleApiLoaded={this.addAutoComplete.bind(
                                  this,
                                )}
                                yesIWantToUseGoogleMapApiInternals
                              >
                                {this.state[this.state.which].geoLoc.lat !==
                                  "" &&
                                  this.state[this.state.which].geoLoc.lng !==
                                    "" && (
                                    <Marker
                                      lat={
                                        this.state[this.state.which].geoLoc.lat
                                      }
                                      lng={
                                        this.state[this.state.which].geoLoc.lng
                                      }
                                    />
                                  )}
                              </GoogleMapReact>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </CardContent>
                    <CardFooter
                      style={{
                        display: this.state.deliveryEdit ? "block" : "none",
                      }}
                    >
                      <Button
                        round
                        fill
                        className="button button-fill-blue"
                        style={{
                          width: "100%",
                        }}
                        disabled={
                          !this.state.deliveryEdit ||
                          this.state.delivery.address.trim() === "" ||
                          this.state.updateDeliveryButton !== "Save"
                        }
                        onClick={this.updateDelivery.bind(this)}
                      >
                        {this.state.updateDeliveryButton}
                      </Button>
                    </CardFooter>
                  </Card>
                </Block>
              ) : (
                // show this block if user is not an agent
                <Block style={{ paddingBottom: "32px" }}>
                  <Card style={{ margin: "auto" }}>
                    <CardHeader
                      className="no-border"
                      style={{ height: "200px" }}
                    >
                      <Row style={{ width: "100%" }}>
                        <Col width="100">
                          <div style={{ width: "160px", margin: "auto" }}>
                            {" "}
                            <PrimaryLogo />{" "}
                          </div>
                        </Col>
                        <Col width="100">
                          <div
                            style={{
                              width: "160px",
                              margin: "10pt auto 0 auto",
                            }}
                          >
                            {" "}
                            <BikeSvg />{" "}
                          </div>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardContent>
                      <h3 style={{ textAlign: "center", margin: 0 }}>
                        Delivery
                      </h3>
                    </CardContent>
                  </Card>

                  <Row style={{ marginTop: "20pt" }}>
                    <Col width="100">
                      <h4 style={{ margin: 0 }}>Delivery</h4>
                      <small style={{ margin: 0 }}>
                        Please sign up to become a delivery agent
                      </small>
                    </Col>
                  </Row>

                  <Card style={{ margin: "20pt auto" }}>
                    <CardHeader className="no-border">Features</CardHeader>
                    <CardContent>
                      <List noHairlinesMd style={{ paddingBottom: "32px" }}>
                        {this.state.featuresAgent.map((value, index) => (
                          <ListItem title={value} key={index}>
                            <Icon f7="checkmark_alt_circle" slot="media" />
                          </ListItem>
                        ))}
                      </List>
                      <Button fill href="/business-registration/2/">
                        Delivery Agent Sign Up
                      </Button>
                    </CardContent>
                  </Card>
                </Block>
              )}

              {/* check if user has branch management access */}
              {!this.props.profile.isEmpty &&
              this.props.profile.managedBranches?.length ? (
                <Block style={{ paddingBottom: "32px", marginTop: "-32px" }}>
                  <Card style={{ margin: " auto" }}>
                    <CardHeader>Delivery Branch</CardHeader>
                    <CardContent>
                      <Button
                        fill
                        href="/branch-dashboard/"
                        className="button button-fill-blue"
                      >
                        Outlet Dashboard
                      </Button>
                    </CardContent>
                  </Card>
                </Block>
              ) : null}
            </Tab>
          ) : null}

          {this.state.showTab == "partners" ? (
            <Tab id="tab-partners">
              {this.props.loadingDoc && !this.props.partners ? (
                <Block className="text-align-center">
                  <Preloader></Preloader>
                </Block>
              ) : !this.props.profile.isEmpty &&
                this.props.profile.partners &&
                this.props.partners &&
                this.props.partners[this.props.auth.uid] ? (
                // show this block if user is already an agent
                <Block style={{ paddingBottom: "32px" }}>
                  <Card style={{ margin: "auto" }}>
                    <CardHeader
                      className="no-border"
                      style={{
                        height: "200px",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundImage:
                          "url(" +
                          this.props.partners[this.props.auth.uid]
                            .businessProfile.images.logo.URL +
                          ")",
                      }}
                    ></CardHeader>
                    <CardContent>
                      <h3 style={{ textAlign: "center", margin: 0 }}>
                        {
                          this.props.partners[this.props.auth.uid]
                            .businessProfile.name
                        }
                      </h3>
                    </CardContent>
                  </Card>

                  <Card style={{ margin: "20pt auto" }}>
                    {this.props.partners[this.props.auth.uid].approved &&
                    this.props.partners[this.props.auth.uid].walletId ? (
                      <CardHeader>
                        <div className="data-table-title">Referral Code</div>
                        <div className="data-table-actions">
                          <Button
                            outline
                            iconF7="doc_on_clipboard"
                            onClick={(e) =>
                              this.$f7.methods.copyText(e, "Referral Code")
                            }
                          >
                            &nbsp;&nbsp;&nbsp;
                            <span className="copytext">
                              {
                                this.props.partners[this.props.auth.uid]
                                  .businessProfile.referralId
                              }
                            </span>
                          </Button>
                        </div>
                      </CardHeader>
                    ) : null}

                    {this.props.partners[this.props.auth.uid].approved &&
                    !this.props.partners[this.props.auth.uid].walletId ? (
                      <CardContent style={{ paddingTop: 0 }}>
                        <Block className="sdab">
                          <Row>
                            <Col width="10">
                              <Icon f7="info_circle_fill" />
                            </Col>
                            <Col width="90">
                              Please add at least one bank detail from your
                              dashboard. This will enable you get your
                              commission from your referral on each sale made
                            </Col>
                          </Row>
                        </Block>
                      </CardContent>
                    ) : null}
                  </Card>

                  {
                    // user has access
                    this.props.partners[this.props.auth.uid].approved &&
                    this.props.partners[this.props.auth.uid].accountStatus !==
                      "Suspended" ? (
                      <Card style={{ margin: "20pt auto" }}>
                        <CardHeader>Dashboard</CardHeader>
                        <CardContent>
                          <Button fill href="/partners/">
                            Referral Dashboard
                          </Button>
                        </CardContent>
                      </Card>
                    ) : // user access pending
                    this.props.partners[this.props.auth.uid].accountStatus ===
                      "Pending" ? (
                      <Card style={{ margin: "20pt auto" }}>
                        <CardHeader className="no-border">
                          Account Status
                        </CardHeader>
                        <CardContent style={{ paddingTop: 0 }}>
                          <Block className="pab">
                            <Row>
                              <Col>
                                <p>Application Pending &nbsp;&nbsp;&nbsp;</p>
                              </Col>
                              <Col>
                                <Link
                                  className="pal"
                                  tabLink="#view-message-master"
                                  onClick={() =>
                                    this.navMessage(
                                      "account",
                                      "admin",
                                      "account",
                                    )
                                  }
                                >
                                  Contact Admin
                                </Link>
                              </Col>
                            </Row>

                            <Row className="pat">
                              <Col>
                                <p style={{ margin: "0", color: " #9E9E9E" }}>
                                  Please contact Admin after 24 hours if account
                                  is still pending.
                                </p>
                              </Col>
                            </Row>
                          </Block>
                        </CardContent>
                      </Card>
                    ) : // user access declined
                    this.props.partners[this.props.auth.uid].accountStatus ===
                      "Declined" ? (
                      <Card style={{ margin: "20pt auto" }}>
                        <CardHeader className="no-border">
                          Account Status
                        </CardHeader>
                        <CardContent style={{ paddingTop: 0 }}>
                          <Block className="sdab">
                            <Row>
                              <Col>
                                <p>Application Declined &nbsp;&nbsp;&nbsp;</p>
                              </Col>
                              <Col>
                                <Link className="sdal" href="/decline/3/">
                                  Reasons
                                </Link>
                              </Col>
                            </Row>
                          </Block>
                        </CardContent>
                      </Card>
                    ) : (
                      //user access suspended
                      <Card style={{ margin: "20pt auto" }}>
                        <CardHeader className="no-border">
                          Account Status
                        </CardHeader>
                        <CardContent style={{ paddingTop: 0 }}>
                          <Block className="sdab">
                            <Row>
                              <Col>
                                <p>Account Suspended &nbsp;&nbsp;&nbsp;</p>
                              </Col>
                              <Col>
                                <Link
                                  className="sdal"
                                  tabLink="#view-message-master"
                                  onClick={() =>
                                    this.navMessage(
                                      "account",
                                      "admin",
                                      "account",
                                    )
                                  }
                                >
                                  Contact Admin
                                </Link>
                              </Col>
                            </Row>
                          </Block>
                        </CardContent>
                      </Card>
                    )
                  }

                  <Row style={{ marginTop: "20pt" }}>
                    <Col width="80">
                      <h4 style={{ margin: 0 }}>Agent Profile</h4>
                      <small style={{ margin: 0 }}>
                        Please ensure details are up to date
                      </small>
                    </Col>
                    <Col width="20">
                      <div
                        className="searchFilterBtn"
                        style={{
                          backgroundColor: this.state.partnersEdit
                            ? "var(--f7-theme-color-shade)"
                            : "",
                        }}
                      >
                        <Link
                          iconF7="pencil_ellipsis_rectangle"
                          onClick={() => {
                            this.setState((prevState) => {
                              return {
                                ...this.state,
                                partnersEdit: !prevState.partnersEdit,
                                displayImageSrc: !prevState.partnersEdit
                                  ? this.props.partners[this.props.auth.uid]
                                      .businessProfile.images.logo.URL
                                  : "",
                                image: !prevState.partnersEdit ? "" : null,
                                which: !prevState.partnersEdit
                                  ? "partners"
                                  : "",
                              };
                            });
                          }}
                        ></Link>
                      </div>
                    </Col>
                  </Row>

                  <Card style={{ margin: "20pt auto" }}>
                    <CardContent>
                      <List noHairlinesMd>
                        <ListInput
                          label="Full Name"
                          type="text"
                          placeholder="Full name"
                          disabled={!this.state.partnersEdit}
                          value={this.state.partners.name}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              partners: {
                                ...this.state.partners,
                                name: e.target.value,
                              },
                            })
                          }
                        >
                          <Icon
                            f7="person"
                            slot="media"
                            style={{
                              color: this.state.partnersEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>

                        <ListInput
                          label="Phone number"
                          type="text"
                          placeholder="eg: 0703xxxxxxx"
                          disabled={!this.state.partnersEdit}
                          value={this.state.partners.phone}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              partners: {
                                ...this.state.partners,
                                phone: e.target.value,
                              },
                            })
                          }
                        >
                          <Icon
                            f7="phone"
                            slot="media"
                            style={{
                              color: this.state.partnersEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>

                        <ListInput
                          label="Email address"
                          type="email"
                          placeholder="name@domain.com"
                          disabled={!this.state.partnersEdit}
                          value={this.state.partners.email}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              partners: {
                                ...this.state.partners,
                                email: e.target.value,
                              },
                            })
                          }
                        >
                          <Icon
                            f7="envelope"
                            slot="media"
                            style={{
                              color: this.state.partnersEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>

                        <ListInput
                          label="Physical address"
                          type="text"
                          placeholder="eg: Apt No., Street, City, State"
                          id="partners_business_address"
                          disabled={!this.state.partnersEdit}
                          value={this.state.partners.address}
                          onBlur={(e) => {
                            if (e.target.value.trim() === "") {
                              return toast(this.$f7.toast, {
                                text: `Please enter a valid address`,
                                position: "bottom",
                                horizontalPosition: "center",
                                closeButton: true,
                                cssClass: "custom-toast",
                                closeTimeout: 4000,
                              });
                            }
                          }}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              [this.state.which]: {
                                ...this.state[this.state.which],

                                address: e.target.value,
                              },
                            })
                          }
                        >
                          <Icon
                            f7="map_pin_ellipse"
                            slot="media"
                            style={{
                              color: this.state.partnersEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>
                        <ListInput
                          label="State"
                          type="select"
                          placeholder="Please select state"
                          info="Select state from dropdown"
                          disabled={!this.state.partnersEdit}
                          required
                          value={this.state.partners.state}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              [this.state.which]: {
                                ...this.state[this.state.which],

                                state: e.target.value,
                              },
                            })
                          }
                        >
                          <option></option>
                          {[
                            ...new Set(
                              cities
                                .filter(
                                  (cityInfo) =>
                                    cityInfo.country ===
                                    this.props.partners[this.props.auth.uid]
                                      .businessProfile.country,
                                )
                                .map((cityInfo) => cityInfo.admin_name),
                            ),
                          ]
                            .sort()
                            .map((stateName, i) => (
                              <option key={i} value={stateName}>
                                {stateName}
                              </option>
                            ))}
                          <Icon
                            f7="globe"
                            slot="media"
                            style={{
                              color: this.state.partnersEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>
                        <ListInput
                          label="City"
                          type="select"
                          placeholder="Please select city"
                          info="Select state from dropdown"
                          required
                          disabled={
                            !this.state.partnersEdit ||
                            this.state.partners.state.trim() === ""
                          }
                          value={this.state.partners.city}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              [this.state.which]: {
                                ...this.state[this.state.which],

                                city: e.target.value,
                              },
                            })
                          }
                        >
                          <option></option>
                          {this.state.partners.state &&
                            [
                              ...new Set(
                                cities
                                  .filter(
                                    (cityInfo) =>
                                      cityInfo.country ===
                                        this.props.partners[this.props.auth.uid]
                                          .businessProfile.country &&
                                      cityInfo.admin_name ===
                                        this.state.partners.state,
                                  )
                                  .map((cityInfo) => cityInfo.city),
                              ),
                            ]
                              .sort()
                              .map((cityName, i) => (
                                <option key={i} value={cityName}>
                                  {cityName}
                                </option>
                              ))}
                          <Icon
                            f7="globe"
                            slot="media"
                            style={{
                              color: this.state.partnersEdit
                                ? "var(--f7-theme-color-shade)"
                                : "",
                            }}
                          />
                        </ListInput>
                      </List>
                      <Row
                        style={{
                          display: this.state.partnersEdit ? "block" : "none",
                          marginTop: "20pt",
                        }}
                      >
                        <Col width="100">
                          <List mediaList>
                            <ListInput
                              className="custom-file-input"
                              label="Buisness Logo"
                              type="file"
                              info="Formats png|jpg|jpeg"
                              onChange={(e) => {
                                const reader = new FileReader();
                                if (reader) {
                                  reader.onload = (e) => {
                                    this.setState({
                                      ...this.state,
                                      displayImageSrc: e.target.result,
                                    });
                                  };
                                  reader.readAsDataURL(e.target.files[0]);
                                }
                                this.setState({
                                  ...this.state,

                                  image: e.target.files[0],
                                });
                              }}
                            >
                              <img
                                slot="media"
                                src={this.state.displayImageSrc}
                                style={{
                                  width: "75px",
                                  height: "75px",
                                  marginLeft: "-13px",
                                  objectFit: "cover",
                                }}
                              />
                            </ListInput>
                          </List>
                        </Col>
                        <Col width="100">
                          <BlockTitle style={{ marginLeft: "0px" }}>
                            Please select business location
                          </BlockTitle>
                          <div
                            id="partnersMap"
                            className="business-map"
                            style={{
                              height: "200px",
                              border: "2px solid #ddd",
                              borderRadius: "6px",
                              marginLeft: "0px",
                            }}
                          >
                            {this.state.partnersEdit && (
                              <GoogleMapReact
                                bootstrapURLKeys={{
                                  key: "AIzaSyBUQs-C3DV8iZ_NYSdjHN--g50yMETXXMY",
                                  libraries: ["places"],
                                }}
                                defaultCenter={{
                                  lat: 59.95,
                                  lng: 30.33,
                                }}
                                center={
                                  this.state[this.state.which].geoLoc.lat !==
                                    "" &&
                                  this.state[this.state.which].geoLoc.lng !== ""
                                    ? this.state[this.state.which].geoLoc
                                    : { lat: 59.95, lng: 30.33 }
                                }
                                defaultZoom={18}
                                layerTypes={["TrafficLayer", "TransitLayer"]}
                                options={{
                                  mapTypeControl: true,
                                  mapTypeControlOptions: {
                                    mapTypeIds: [
                                      "roadmap",
                                      "terrain",
                                      "satellite",
                                    ],
                                  },
                                }}
                                onClick={this.mapClicked.bind(this)}
                                onGoogleApiLoaded={this.addAutoComplete.bind(
                                  this,
                                )}
                                yesIWantToUseGoogleMapApiInternals
                              >
                                {this.state[this.state.which].geoLoc.lat !==
                                  "" &&
                                  this.state[this.state.which].geoLoc.lng !==
                                    "" && (
                                    <Marker
                                      lat={
                                        this.state[this.state.which].geoLoc.lat
                                      }
                                      lng={
                                        this.state[this.state.which].geoLoc.lng
                                      }
                                    />
                                  )}
                              </GoogleMapReact>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </CardContent>
                    <CardFooter
                      style={{
                        display: this.state.partnersEdit ? "block" : "none",
                      }}
                    >
                      <Button
                        round
                        fill
                        className="button button-fill-blue"
                        style={{
                          width: "100%",
                        }}
                        disabled={
                          !this.state.partnersEdit ||
                          this.state.partners.address.trim() === "" ||
                          this.state.updatePartnersButton !== "Save"
                        }
                        onClick={this.updatePartners.bind(this)}
                      >
                        {this.state.updatePartnersButton}
                      </Button>
                    </CardFooter>
                  </Card>
                </Block>
              ) : (
                // show this block if user is not an agent
                <Block style={{ paddingBottom: "32px" }}>
                  <Card style={{ margin: "auto" }}>
                    <CardHeader
                      className="no-border"
                      style={{ height: "200px" }}
                    >
                      <Row style={{ width: "100%" }}>
                        <Col width="100">
                          <div style={{ width: "160px", margin: "auto" }}>
                            {" "}
                            <PrimaryLogo />{" "}
                          </div>
                        </Col>
                        <Col width="100">
                          <div
                            style={{
                              width: "160px",
                              margin: "10pt auto 0 auto",
                            }}
                          >
                            {" "}
                            <AgentSvg />{" "}
                          </div>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardContent>
                      <h3 style={{ textAlign: "center", margin: 0 }}>
                        Easychaw Agent
                      </h3>
                    </CardContent>
                  </Card>

                  <Row style={{ marginTop: "20pt" }}>
                    <Col width="100">
                      <h4 style={{ margin: 0 }}>Easychaw Agent</h4>
                      <small style={{ margin: 0 }}>
                        Please sign up to become an Easychaw Agent
                      </small>
                    </Col>
                  </Row>

                  <Card style={{ margin: "20pt auto" }}>
                    <CardHeader className="no-border">Features</CardHeader>
                    <CardContent>
                      <List noHairlinesMd>
                        {this.state.featuresEasychawAgent.map(
                          (value, index) => (
                            <ListItem title={value} key={index}>
                              <Icon f7="checkmark_alt_circle" slot="media" />
                            </ListItem>
                          ),
                        )}
                      </List>
                    </CardContent>
                  </Card>
                  <Button round fill href="/business-registration/3/">
                    Easychaw Agent Sign Up
                  </Button>
                </Block>
              )}
            </Tab>
          ) : null}

          {this.state.showTab == "info" ? (
            <Tab id="tab-info">
              <Block style={{ paddingBottom: "40px" }}>
                <Card style={{ margin: "auto" }}>
                  <CardHeader
                    className="no-border bg-color-theme bg-image-pattern"
                    style={{
                      backgroundSize: "50%",
                      height: "200px",
                    }}
                  >
                    <img
                      src="static/logo.svg"
                      style={{
                        width: "128px",
                        height: "128px",
                        margin: "auto",
                      }}
                    />
                  </CardHeader>
                  <CardContent>
                    <h6 style={{ margin: 0, textAlign: "center" }}>
                      version {this.$f7.version}
                    </h6>
                  </CardContent>
                </Card>

                <Link
                  href="/website/about/"
                  style={{
                    display: "block",
                    color: "#444444",
                  }}
                >
                  <Card style={{ margin: "15pt auto" }}>
                    <CardContent padding={false}>
                      <Row noGap={true}>
                        <Col
                          width="5"
                          className="bg-image-pattern"
                          style={{
                            height: "100px",
                            backgroundSize: "350%",
                            backgroundColor: "#ffecae",
                            borderTopLeftRadius: "4px",
                            borderBottomLeftRadius: "4px",
                          }}
                        />
                        <Col width="60" large="65">
                          <Block>
                            <Row>
                              <Col width="100">
                                <h2 style={{ fontFamily: "Italiana" }}>
                                  About Easychaw
                                </h2>
                              </Col>
                              <Col width="100">
                                <small style={{ color: "#8e8e93" }}>
                                  continue <Icon f7="arrow_right" />
                                </small>
                              </Col>
                            </Row>
                          </Block>
                        </Col>
                        <Col
                          width="35"
                          large="30"
                          style={{
                            backgroundImage:
                              "url(static/logo.svg), linear-gradient(0deg, rgba(223,171,1,1) 0%, rgba(254,202,32,1) 35%, rgba(254,212,72,1) 100%)",
                            height: "100px",
                            backgroundSize: "60%, cover",
                            backgroundPosition: "center",
                            backgroundColor: "#fed448",
                            backgroundRepeat: "no-repeat",
                            borderTopRightRadius: "4px",
                            borderBottomRightRadius: "4px",
                          }}
                        />
                      </Row>
                    </CardContent>
                  </Card>
                </Link>

                <Link
                  href="/website/faq/"
                  style={{
                    display: "block",
                    color: "#444444",
                  }}
                >
                  <Card style={{ margin: "15pt auto" }}>
                    <CardContent padding={false}>
                      <Row noGap={true}>
                        <Col
                          width="5"
                          className="bg-image-pattern"
                          style={{
                            height: "100px",
                            backgroundSize: "350%",
                            backgroundColor: "#ffecae",
                            borderTopLeftRadius: "4px",
                            borderBottomLeftRadius: "4px",
                          }}
                        />
                        <Col width="60" large="65">
                          <Block>
                            <Row>
                              <Col width="100">
                                <h2 style={{ fontFamily: "Italiana" }}>
                                  Help FAQ
                                </h2>
                              </Col>
                              <Col width="100">
                                <small style={{ color: "#8e8e93" }}>
                                  continue <Icon f7="arrow_right" />
                                </small>
                              </Col>
                            </Row>
                          </Block>
                        </Col>
                        <Col
                          width="35"
                          large="30"
                          style={{
                            backgroundImage:
                              "url(static/faq.svg), linear-gradient(0deg, rgba(223,171,1,1) 0%, rgba(254,202,32,1) 35%, rgba(254,212,72,1) 100%)",
                            height: "100px",
                            backgroundSize: "70%, cover",
                            backgroundPosition: "center",
                            backgroundColor: "#fed448",
                            backgroundRepeat: "no-repeat",
                            borderTopRightRadius: "4px",
                            borderBottomRightRadius: "4px",
                          }}
                        />
                      </Row>
                    </CardContent>
                  </Card>
                </Link>

                <Link
                  href="/website/how/"
                  style={{
                    display: "block",
                    color: "#444444",
                  }}
                >
                  <Card style={{ margin: "15pt auto" }}>
                    <CardContent padding={false}>
                      <Row noGap={true}>
                        <Col
                          width="5"
                          className="bg-image-pattern"
                          style={{
                            height: "100px",
                            backgroundSize: "350%",
                            backgroundColor: "#ffecae",
                            borderTopLeftRadius: "4px",
                            borderBottomLeftRadius: "4px",
                          }}
                        />
                        <Col width="60" large="65">
                          <Block style={{ paddingRight: 0 }}>
                            <Row>
                              <Col width="100">
                                <h2 style={{ fontFamily: "Italiana" }}>
                                  How To Videos
                                </h2>
                              </Col>
                              <Col width="100">
                                <small style={{ color: "#8e8e93" }}>
                                  continue <Icon f7="arrow_right" />
                                </small>
                              </Col>
                            </Row>
                          </Block>
                        </Col>
                        <Col
                          width="35"
                          large="30"
                          style={{
                            backgroundImage:
                              "url(./static/user.png), linear-gradient(0deg, rgba(223,171,1,1) 0%, rgba(254,202,32,1) 35%, rgba(254,212,72,1) 100%)",
                            height: "100px",
                            backgroundSize: "contain",
                            backgroundPosition: "top center",
                            backgroundColor: "#fed448",
                            backgroundRepeat: "no-repeat",
                            borderTopRightRadius: "4px",
                            borderBottomRightRadius: "4px",
                          }}
                        />
                      </Row>
                    </CardContent>
                  </Card>
                </Link>
              </Block>
            </Tab>
          ) : null}
        </Tabs>
        <div className="blankDetailSVG">
          <BlankDetailSvg size="300px" />
          <p>Select menu options from master view</p>
        </div>
      </Page>
    );
  }

  // Lifecycle methods
  static getDerivedStateFromProps(nextProps, prevState) {
    if (!nextProps.auth.isEmpty) {
      let objectToReturn = {};

      if (!nextProps.profile.isEmpty && !prevState.edit) {
        objectToReturn = {
          ...objectToReturn,
          profile: {
            ...prevState.profile,
            email: nextProps.profile.email,
            fullName: nextProps.profile.fullName,
            phoneNumber: nextProps.profile.phoneNumber || "",
            homeLocation: {
              address: nextProps.profile.homeLocation?.address || "",
              geoLoc: nextProps.profile.homeLocation?.geoLoc || null,
            },
            workLocation: {
              address: nextProps.profile.workLocation?.address || "",
              geoLoc: nextProps.profile.workLocation?.geoLoc || null,
            },
          },
        };
      }

      if (
        nextProps.merchants &&
        nextProps.merchants[nextProps.auth.uid] &&
        !prevState.merchantEdit
      ) {
        objectToReturn = {
          ...objectToReturn,
          merchant: {
            ...prevState.merchant,
            businessLogo:
              nextProps.merchants[nextProps.auth.uid].businessProfile.images
                .logo.URL,
            name: nextProps.merchants[nextProps.auth.uid].businessProfile.name,
            phone:
              nextProps.merchants[nextProps.auth.uid].businessProfile.phone,
            email:
              nextProps.merchants[nextProps.auth.uid].businessProfile.email,
            address:
              nextProps.merchants[nextProps.auth.uid].businessProfile.address,
            slogan:
              nextProps.merchants[nextProps.auth.uid].businessProfile.slogan,
            state:
              nextProps.merchants[nextProps.auth.uid].businessProfile.state ||
              "",
            city:
              nextProps.merchants[nextProps.auth.uid].businessProfile.city ||
              "",
            geoLoc: {
              ...nextProps.merchants[nextProps.auth.uid].businessProfile.geoLoc,
            },
          },
        };
      }

      if (
        nextProps.delivery &&
        nextProps.delivery[nextProps.auth.uid] &&
        !prevState.deliveryEdit
      ) {
        objectToReturn = {
          ...objectToReturn,
          delivery: {
            ...prevState.delivery,
            businessLogo:
              nextProps.delivery[nextProps.auth.uid].businessProfile.images.logo
                .URL,
            name: nextProps.delivery[nextProps.auth.uid].businessProfile.name,
            phone: nextProps.delivery[nextProps.auth.uid].businessProfile.phone,
            email: nextProps.delivery[nextProps.auth.uid].businessProfile.email,
            category:
              nextProps.delivery[nextProps.auth.uid].businessProfile.category,
            address:
              nextProps.delivery[nextProps.auth.uid].businessProfile.address,
            slogan:
              nextProps.delivery[nextProps.auth.uid].businessProfile.slogan,
            state:
              nextProps.delivery[nextProps.auth.uid].businessProfile.state ||
              "",
            city:
              nextProps.delivery[nextProps.auth.uid].businessProfile.city || "",
            geoLoc: {
              ...nextProps.delivery[nextProps.auth.uid].businessProfile.geoLoc,
            },
          },
        };
      }

      if (
        nextProps.partners &&
        nextProps.partners[nextProps.auth.uid] &&
        !prevState.partnersEdit
      ) {
        objectToReturn = {
          ...objectToReturn,
          partners: {
            ...prevState.partners,
            businessLogo:
              nextProps.partners[nextProps.auth.uid].businessProfile.images.logo
                .URL,
            name: nextProps.partners[nextProps.auth.uid].businessProfile.name,
            phone: nextProps.partners[nextProps.auth.uid].businessProfile.phone,
            email: nextProps.partners[nextProps.auth.uid].businessProfile.email,
            address:
              nextProps.partners[nextProps.auth.uid].businessProfile.address,
            state:
              nextProps.partners[nextProps.auth.uid].businessProfile.state ||
              "",
            city:
              nextProps.partners[nextProps.auth.uid].businessProfile.city || "",
            geoLoc: {
              ...nextProps.partners[nextProps.auth.uid].businessProfile.geoLoc,
            },
          },
        };
      }

      if (Object.keys(objectToReturn).length > 0) {
        return objectToReturn;
      } else {
        return null;
      }
    }

    return null;
  }

  componentDidMount() {
    if (this.state.showTab === "profile") {
      const interval = setInterval(() => {
        if (window.google) {
          this.addProfileAutocomplete("homeAddress", "home");
          this.addProfileAutocomplete("workAddress", "work");

          clearInterval(this.state.profileInterval);
        }
      }, 1000);

      this.setState({
        ...this.state,
        profileInterval: interval,
      });
    }
  }

  // Events
  onPageAfterIn() {
    const self = this.$f7;

    // notify user to register delivery company if they filled ownsDelivery as yes
    if (this.state.showTab == "merchant") {
      !this.props.profile.deliveryServices &&
      this.props.merchants &&
      this.props.merchants[this.props.auth.uid].businessProfile.ownsDelivery ===
        "Yes"
        ? toast(this.$f7.toast, {
            text: "Please register your delivery business",
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 10000,
          })
        : null;
    }
  }

  // Add autocomplete to input fields
  addProfileAutocomplete(inputId, type) {
    const input = document.querySelector(`#${inputId} input`);
    const autocomplete = new window.google.maps.places.Autocomplete(input);
    autocomplete.setFields(["formatted_address", "geometry", "name"]);
    autocomplete.addListener("place_changed", () => {
      let response = autocomplete.getPlace();
      if (!response.geometry) {
        return toast(this.$f7.toast, {
          text: `No details available for input: ${response.name}. Please make sure you select a suggestted place`,
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      }

      if (response) {
        const locationData = {
          address: response.name,
          geoLoc: {
            lat: response.geometry.location.lat(),
            lng: response.geometry.location.lng(),
          },
        };

        if (type === "home") {
          this.setState({
            ...this.state,
            profile: {
              ...this.state.profile,
              homeLocation: {
                ...locationData,
              },
            },
          });
        } else {
          this.setState({
            ...this.state,
            profile: {
              ...this.state.profile,
              workLocation: {
                ...locationData,
              },
            },
          });
        }
      }
    });
  }

  navMessage(...args) {
    const self = this;
    const messageReceiverID = args[1] ? args[1] : "admin";
    const previousView = args[0] ? args[0] : "account";
    const previousPage = args[2] ? args[2] : "account";

    self.$f7.views["message-master"].router.navigate(
      {
        name: "message-master",
        params: {
          view: previousView,
          id: messageReceiverID,
          page: previousPage,
        },
      },
      {
        reloadAll: true,
      },
    );
  }

  updateMerchant() {
    this.setState({
      ...this.state,
      updateMerchantButton: "Saving...",
      edit: false,
      deliveryEdit: false,
      partnersEdit: false,
    });
    let editedMerchant = {};

    Object.keys(this.state.merchant).forEach((key) => {
      if (key !== "businessLogo") {
        if (
          key === "geoLoc" &&
          (this.state.merchant[key].lat !==
            this.props.merchants[this.props.auth.uid].businessProfile[key]
              .lat ||
            this.state.merchant[key].lng !==
              this.props.merchants[this.props.auth.uid].businessProfile[key]
                .lng)
        ) {
          editedMerchant[key] = { ...this.state.merchant[key] };
        }

        if (
          key !== "geoLoc" &&
          this.state.merchant[key] !==
            this.props.merchants[this.props.auth.uid].businessProfile[key]
        ) {
          editedMerchant[key] = this.state.merchant[key];
        }
      }
    });

    if (
      Object.keys(editedMerchant).length > 0 ||
      this.state.image !== null ||
      this.state.image !== ""
    ) {
      if (Object.keys(editedMerchant).length > 0) {
        let error = false;
        Object.keys(editedMerchant).forEach((key) => {
          if (key !== "geoLoc" && editedMerchant[key].trim() === "") {
            error = true;
          }
        });

        if (error) {
          toast(this.$f7.toast, {
            text: "Fields cannot be empty",
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
          return this.setState({
            ...this.state,
            merchantEdit: false,
            updateMerchantButton: "Save",
          });
        }
      }

      this.$f7.preloader.show();
      this.props.firebase
        .auth()
        .currentUser.getIdToken(true)
        .then((idToken) => {
          // send OTP to merchant's email
          sendOneTimePassword(
            {
              type: "merchants",
              token: idToken,
              uid: this.props.auth.uid,
              reason: "Profile changes",
            },
            (error, sent) => {
              if (error || !sent) {
                this.setState({
                  ...this.state,
                  merchantEdit: false,
                  updateMerchantButton: "Save",
                });
                this.$f7.preloader.hide();
                return toast(this.$f7.toast, {
                  text: error,
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
              }

              // open a dialog to confirm OTP
              this.$f7.preloader.hide();
              this.$f7.dialog
                .create({
                  title: "OTP CODE",
                  cssClass: "otp-code-modal",
                  text: "Confirm changes by filling in the OTP code sent to your email address",
                  content: `<input class="dialog-input split-input" type="password" maxlength="4"/>`,
                  buttons: [
                    // button to resend otp
                    {
                      text: "Resend Code",
                      color: "gray",
                      cssClass: "otp-resend",

                      close: false,
                      onClick: (dialog, e) => {
                        this.$f7.preloader.show();
                        sendOneTimePassword(
                          {
                            type: "merchants",
                            token: idToken,
                            uid: this.props.auth.uid,
                            reason: "Profile changes",
                          },
                          (error, sent) => {
                            if (error || !sent) {
                              this.setState({
                                ...this.state,
                                merchantEdit: false,
                                updateMerchantButton: "Save",
                              });

                              this.$f7.preloader.hide();
                              return toast(this.$f7.toast, {
                                text: error,
                                position: "bottom",
                                horizontalPosition: "center",
                                closeButton: true,
                                cssClass: "custom-toast",
                                closeTimeout: 4000,
                              });
                            }

                            this.$f7.preloader.hide();
                            return toast(this.$f7.toast, {
                              text: "OTP code sent",
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                          },
                        );
                      },
                    },
                    // button to cancel
                    {
                      text: "x",
                      color: "white",
                      cssClass: "otp-close",
                      onClick: (dialog, e) => {
                        this.setState({
                          ...this.state,
                          merchantEdit: false,
                          updateMerchantButton: "Save",
                        });
                        this.$f7.preloader.hide();
                      },
                    },
                    // button to continue
                    {
                      text: "Continue",
                      bold: true,
                      cssClass: "otp-continue",
                      keyCodes: [13],
                      close: false,
                      onClick: (dialog, e) => {
                        this.$f7.preloader.show();
                        // password
                        const password = dialog.$el.find(".dialog-input").val();

                        // Verify otp
                        verifyOneTimePassword(
                          {
                            password,
                            type: "merchants",
                            token: idToken,
                            uid: this.props.auth.uid,
                            reason: "Profile changes",
                          },
                          (error, success) => {
                            if (error || !success) {
                              this.$f7.preloader.hide();
                              return toast(this.$f7.toast, {
                                text: error,
                                position: "bottom",
                                horizontalPosition: "center",
                                closeButton: true,
                                cssClass: "custom-toast",
                                closeTimeout: 4000,
                              });
                            }

                            // close dialog
                            dialog.close();

                            if (editedMerchant.phone || editedMerchant.email) {
                              let checks = [];
                              if (editedMerchant.phone) {
                                if (editedMerchant.phone.trim().length !== 11) {
                                  this.$f7.preloader.hide();
                                  toast(this.$f7.toast, {
                                    text: "Invalid phone number. Phone number must be 11 digits",
                                    position: "bottom",
                                    horizontalPosition: "center",
                                    closeButton: true,
                                    cssClass: "custom-toast",
                                    closeTimeout: 4000,
                                  });
                                  return this.setState({
                                    ...this.state,
                                    merchantEdit: false,
                                    updateMerchantButton: "Save",
                                  });
                                }
                                checks.push(
                                  isAllowedVendorsAndAgents({
                                    token: idToken,
                                    uid: this.props.auth.uid,
                                    details: {
                                      collection: "merchants",
                                      value: editedMerchant.phone,
                                      property: "phone",
                                    },
                                  }),
                                );
                              }

                              if (editedMerchant.email) {
                                // verify email
                                if (!isValidEmail(editedMerchant.email)) {
                                  this.$f7.preloader.hide();
                                  toast(this.$f7.toast, {
                                    text: "Invalid email address",
                                    position: "bottom",
                                    horizontalPosition: "center",
                                    closeButton: true,
                                    cssClass: "custom-toast",
                                    closeTimeout: 4000,
                                  });
                                  return this.setState({
                                    ...this.state,
                                    merchantEdit: false,
                                    updateMerchantButton: "Save",
                                  });
                                }

                                checks.push(
                                  isAllowedVendorsAndAgents({
                                    token: idToken,
                                    uid: this.props.auth.uid,
                                    details: {
                                      collection: "merchants",
                                      value: editedMerchant.email,
                                      property: "email",
                                    },
                                  }),
                                );
                              }

                              axios
                                .all(checks)
                                .then(
                                  axios.spread((...resArray) => {
                                    editedMerchant = {
                                      ...this.props.merchants[
                                        this.props.auth.uid
                                      ].businessProfile,
                                      ...editedMerchant,
                                    };

                                    // check if image or logo is changed
                                    if (
                                      this.state.image === null ||
                                      this.state.image === ""
                                    ) {
                                      this.props.firestore
                                        .collection("merchants")
                                        .doc(this.props.auth.uid)
                                        .update({
                                          businessProfile: {
                                            ...editedMerchant,
                                          },
                                        })
                                        .then(() => {
                                          this.$f7.preloader.hide();
                                          toast(this.$f7.toast, {
                                            text: "Merchant profile details updated",
                                            position: "bottom",
                                            horizontalPosition: "center",
                                            closeButton: true,
                                            cssClass: "custom-toast",
                                            closeTimeout: 4000,
                                          });
                                          this.setState({
                                            ...this.state,
                                            merchantEdit: false,
                                            updateMerchantButton: "Save",
                                          });
                                        })
                                        .catch((error) => {
                                          this.$f7.preloader.hide();
                                          toast(this.$f7.toast, {
                                            text: handleErrors(error),
                                            position: "bottom",
                                            horizontalPosition: "center",
                                            closeButton: true,
                                            cssClass: "custom-toast",
                                            closeTimeout: 4000,
                                          });
                                          this.setState({
                                            ...this.state,
                                            merchantEdit: false,
                                            updateMerchantButton: "Save",
                                          });
                                        });
                                    } else {
                                      // validate image
                                      if (
                                        ![
                                          "image/jpg",
                                          "image/png",
                                          "image/jpeg",
                                        ].includes(this.state.image.type)
                                      ) {
                                        this.$f7.preloader.hide();
                                        this.setState({
                                          ...this.state,
                                          merchantEdit: false,
                                          updateMerchantButton: "Save",
                                        });
                                        return toast(this.$f7.toast, {
                                          text: `${text} should be a valid image`,
                                          position: "bottom",
                                          horizontalPosition: "center",
                                          closeButton: true,
                                          cssClass: "custom-toast",
                                          closeTimeout: 4000,
                                        });
                                      }

                                      if (this.state.image.size > 10000000) {
                                        this.$f7.preloader.hide();
                                        this.setState({
                                          ...this.state,
                                          merchantEdit: false,
                                          updateMerchantButton: "Save",
                                        });
                                        return toast(this.$f7.toast, {
                                          text: `${text} should be below 10MB`,
                                          position: "bottom",
                                          horizontalPosition: "center",
                                          closeButton: true,
                                          cssClass: "custom-toast",
                                          closeTimeout: 4000,
                                        });
                                      }

                                      // delete old logo
                                      deleteFiles(
                                        this.props.storage,
                                        this.props.merchants[
                                          this.props.auth.uid
                                        ].businessProfile.images.logo.path,
                                        (error, success) => {
                                          if (
                                            error &&
                                            error.code !==
                                              "storage/object-not-found"
                                          ) {
                                            this.$f7.preloader.hide();
                                            this.setState({
                                              ...this.state,
                                              merchantEdit: false,
                                              updateMerchantButton: "Save",
                                            });
                                            return toast(this.$f7.toast, {
                                              text: handleErrors(error),
                                              position: "bottom",
                                              horizontalPosition: "center",
                                              closeButton: true,
                                              cssClass: "custom-toast",
                                              closeTimeout: 4000,
                                            });
                                          }

                                          uploadFile(
                                            this.props.storage,
                                            "businesslogo",
                                            this.props.auth.uid,
                                            this.state.image,
                                            (error, imageObject) => {
                                              if (error) {
                                                this.$f7.preloader.hide();
                                                this.setState({
                                                  ...this.state,
                                                  merchantEdit: false,
                                                  updateMerchantButton: "Save",
                                                });
                                                return toast(this.$f7.toast, {
                                                  text: handleErrors(error),
                                                  position: "bottom",
                                                  horizontalPosition: "center",
                                                  closeButton: true,
                                                  cssClass: "custom-toast",
                                                  closeTimeout: 4000,
                                                });
                                              }

                                              editedMerchant = {
                                                ...editedMerchant,
                                                images: {
                                                  ...editedMerchant.images,
                                                  logo: imageObject,
                                                },
                                              };

                                              this.props.firestore
                                                .collection("merchants")
                                                .doc(this.props.auth.uid)
                                                .update({
                                                  businessProfile: {
                                                    ...editedMerchant,
                                                  },
                                                })
                                                .then(() => {
                                                  this.$f7.preloader.hide();
                                                  toast(this.$f7.toast, {
                                                    text: "Merchant profile details updated",
                                                    position: "bottom",
                                                    horizontalPosition:
                                                      "center",
                                                    closeButton: true,
                                                    cssClass: "custom-toast",
                                                    closeTimeout: 4000,
                                                  });
                                                  this.setState({
                                                    ...this.state,
                                                    merchantEdit: false,
                                                    updateMerchantButton:
                                                      "Save",
                                                  });
                                                })
                                                .catch((error) => {
                                                  this.$f7.preloader.hide();
                                                  toast(this.$f7.toast, {
                                                    text: handleErrors(error),
                                                    position: "bottom",
                                                    horizontalPosition:
                                                      "center",
                                                    closeButton: true,
                                                    cssClass: "custom-toast",
                                                    closeTimeout: 4000,
                                                  });
                                                  this.setState({
                                                    ...this.state,
                                                    merchantEdit: false,
                                                    updateMerchantButton:
                                                      "Save",
                                                  });
                                                });
                                            },
                                          );
                                        },
                                      );
                                    }
                                  }),
                                )
                                .catch((error) => {
                                  this.$f7.preloader.hide();
                                  if (error.response) {
                                    toast(this.$f7.toast, {
                                      text: error.response.data.message,
                                      position: "bottom",
                                      horizontalPosition: "center",
                                      closeButton: true,
                                      cssClass: "custom-toast",
                                      closeTimeout: 4000,
                                    });
                                  } else if (error.request) {
                                    toast(this.$f7.toast, {
                                      text: error.request,
                                      position: "bottom",
                                      horizontalPosition: "center",
                                      closeButton: true,
                                      cssClass: "custom-toast",
                                      closeTimeout: 4000,
                                    });
                                  } else {
                                    // Something happened in setting up the request that triggered an Error
                                    toast(this.$f7.toast, {
                                      text: error.message,
                                      position: "bottom",
                                      horizontalPosition: "center",
                                      closeButton: true,
                                      cssClass: "custom-toast",
                                      closeTimeout: 4000,
                                    });
                                  }

                                  return this.setState({
                                    ...this.state,
                                    merchantEdit: false,
                                    updateMerchantButton: "Save",
                                  });
                                });
                            } else {
                              editedMerchant = {
                                ...this.props.merchants[this.props.auth.uid]
                                  .businessProfile,
                                ...editedMerchant,
                              };

                              // check if image or logo is changed
                              if (
                                this.state.image === null ||
                                this.state.image === ""
                              ) {
                                this.props.firestore
                                  .collection("merchants")
                                  .doc(this.props.auth.uid)
                                  .update({
                                    businessProfile: {
                                      ...editedMerchant,
                                    },
                                  })
                                  .then(() => {
                                    this.$f7.preloader.hide();
                                    toast(this.$f7.toast, {
                                      text: "Merchant profile details updated",
                                      position: "bottom",
                                      horizontalPosition: "center",
                                      closeButton: true,
                                      cssClass: "custom-toast",
                                      closeTimeout: 4000,
                                    });
                                    this.setState({
                                      ...this.state,
                                      merchantEdit: false,
                                      updateMerchantButton: "Save",
                                    });
                                  })
                                  .catch((error) => {
                                    this.$f7.preloader.hide();
                                    toast(this.$f7.toast, {
                                      text: handleErrors(error),
                                      position: "bottom",
                                      horizontalPosition: "center",
                                      closeButton: true,
                                      cssClass: "custom-toast",
                                      closeTimeout: 4000,
                                    });
                                    this.setState({
                                      ...this.state,
                                      merchantEdit: false,
                                      updateMerchantButton: "Save",
                                    });
                                  });
                              } else {
                                // validate image
                                if (
                                  ![
                                    "image/jpg",
                                    "image/png",
                                    "image/jpeg",
                                  ].includes(this.state.image.type)
                                ) {
                                  this.$f7.preloader.hide();
                                  this.setState({
                                    ...this.state,
                                    merchantEdit: false,
                                    updateMerchantButton: "Save",
                                  });
                                  return toast(this.$f7.toast, {
                                    text: `${text} should be a valid image`,
                                    position: "bottom",
                                    horizontalPosition: "center",
                                    closeButton: true,
                                    cssClass: "custom-toast",
                                    closeTimeout: 4000,
                                  });
                                }

                                if (this.state.image.size > 10000000) {
                                  this.$f7.preloader.hide();
                                  this.setState({
                                    ...this.state,
                                    merchantEdit: false,
                                    updateMerchantButton: "Save",
                                  });
                                  return toast(this.$f7.toast, {
                                    text: `${text} should be below 10MB`,
                                    position: "bottom",
                                    horizontalPosition: "center",
                                    closeButton: true,
                                    cssClass: "custom-toast",
                                    closeTimeout: 4000,
                                  });
                                }

                                // delete old logo
                                deleteFiles(
                                  this.props.storage,
                                  this.props.merchants[this.props.auth.uid]
                                    .businessProfile.images.logo.path,
                                  (error, success) => {
                                    if (
                                      error &&
                                      error.code !== "storage/object-not-found"
                                    ) {
                                      this.$f7.preloader.hide();
                                      this.setState({
                                        ...this.state,
                                        merchantEdit: false,
                                        updateMerchantButton: "Save",
                                      });
                                      return toast(this.$f7.toast, {
                                        text: handleErrors(error),
                                        position: "bottom",
                                        horizontalPosition: "center",
                                        closeButton: true,
                                        cssClass: "custom-toast",
                                        closeTimeout: 4000,
                                      });
                                    }

                                    uploadFile(
                                      this.props.storage,
                                      "businesslogo",
                                      this.props.auth.uid,
                                      this.state.image,
                                      (error, imageObject) => {
                                        if (error) {
                                          this.$f7.preloader.hide();
                                          this.setState({
                                            ...this.state,
                                            merchantEdit: false,
                                            updateMerchantButton: "Save",
                                          });
                                          return toast(this.$f7.toast, {
                                            text: handleErrors(error),
                                            position: "bottom",
                                            horizontalPosition: "center",
                                            closeButton: true,
                                            cssClass: "custom-toast",
                                            closeTimeout: 4000,
                                          });
                                        }

                                        editedMerchant = {
                                          ...editedMerchant,
                                          images: {
                                            ...editedMerchant.images,
                                            logo: imageObject,
                                          },
                                        };

                                        this.props.firestore
                                          .collection("merchants")
                                          .doc(this.props.auth.uid)
                                          .update({
                                            businessProfile: {
                                              ...editedMerchant,
                                            },
                                          })
                                          .then(() => {
                                            this.$f7.preloader.hide();
                                            toast(this.$f7.toast, {
                                              text: "Merchant profile details updated",
                                              position: "bottom",
                                              horizontalPosition: "center",
                                              closeButton: true,
                                              cssClass: "custom-toast",
                                              closeTimeout: 4000,
                                            });
                                            this.setState({
                                              ...this.state,
                                              merchantEdit: false,
                                              updateMerchantButton: "Save",
                                            });
                                          })
                                          .catch((error) => {
                                            this.$f7.preloader.hide();
                                            toast(this.$f7.toast, {
                                              text: handleErrors(error),
                                              position: "bottom",
                                              horizontalPosition: "center",
                                              closeButton: true,
                                              cssClass: "custom-toast",
                                              closeTimeout: 4000,
                                            });
                                            this.setState({
                                              ...this.state,
                                              merchantEdit: false,
                                              updateMerchantButton: "Save",
                                            });
                                          });
                                      },
                                    );
                                  },
                                );
                              }
                            }
                          },
                        );
                      },
                    },
                  ],
                })
                .open();
            },
          );
        })
        .catch((error) => {
          this.$f7.preloader.hide();
          toast(this.$f7.toast, {
            text: handleErrors(error),
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
          return this.setState({
            ...this.state,
            merchantEdit: false,
            updateMerchantButton: "Save",
          });
        });
    } else {
      this.setState({
        ...this.state,
        merchantEdit: false,
        updateMerchantButton: "Save",
      });
    }
  }

  updateDelivery() {
    this.setState({
      ...this.state,
      updateDeliveryButton: "Saving...",
      edit: false,
      merchantEdit: false,
      partnersEdit: false,
    });
    let editedDelivery = {};

    Object.keys(this.state.delivery).forEach((key) => {
      if (key !== "businessLogo") {
        if (
          key === "geoLoc" &&
          (this.state.delivery[key].lat !==
            this.props.delivery[this.props.auth.uid].businessProfile[key].lat ||
            this.state.delivery[key].lng !==
              this.props.delivery[this.props.auth.uid].businessProfile[key].lng)
        ) {
          editedDelivery[key] = { ...this.state.delivery[key] };
        }

        if (
          key !== "geoLoc" &&
          this.state.delivery[key] !==
            this.props.delivery[this.props.auth.uid].businessProfile[key]
        ) {
          editedDelivery[key] = this.state.delivery[key];
        }
      }
    });

    if (
      Object.keys(editedDelivery).length > 0 ||
      this.state.image !== null ||
      this.state.image !== ""
    ) {
      if (Object.keys(editedDelivery).length > 0) {
        let error = false;
        Object.keys(editedDelivery).forEach((key) => {
          if (key !== "geoLoc" && editedDelivery[key].trim() === "") {
            error = true;
          }
        });

        if (error) {
          toast(this.$f7.toast, {
            text: "Fields cannot be empty",
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
          return this.setState({
            ...this.state,
            deliveryEdit: false,
            updateDeliveryButton: "Save",
          });
        }
      }

      this.$f7.preloader.show();

      this.props.firebase
        .auth()
        .currentUser.getIdToken(true)
        .then((idToken) => {
          // send OTP to merchant's email
          sendOneTimePassword(
            {
              type: "delivery",
              token: idToken,
              uid: this.props.auth.uid,
              reason: "Profile changes",
            },
            (error, sent) => {
              if (error || !sent) {
                this.setState({
                  ...this.state,
                  deliveryEdit: false,
                  updateDeliveryButton: "Save",
                });
                this.$f7.preloader.hide();
                return toast(this.$f7.toast, {
                  text: error,
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
              }

              // open a dialog to confirm OTP
              this.$f7.preloader.hide();
              this.$f7.dialog
                .create({
                  title: "OTP CODE",
                  cssClass: "otp-code-modal",
                  text: "Confirm changes by filling in the OTP code sent to your email address",
                  content: `<input class="dialog-input split-input" type="password" maxlength="4"/>`,
                  buttons: [
                    // button to resend otp
                    {
                      text: "Resend Code",
                      color: "gray",
                      cssClass: "otp-resend",

                      close: false,
                      onClick: (dialog, e) => {
                        this.$f7.preloader.show();
                        sendOneTimePassword(
                          {
                            type: "delivery",
                            token: idToken,
                            uid: this.props.auth.uid,
                            reason: "Profile changes",
                          },
                          (error, sent) => {
                            if (error || !sent) {
                              this.setState({
                                ...this.state,
                                deliveryEdit: false,
                                updateDeliveryButton: "Save",
                              });

                              this.$f7.preloader.hide();
                              return toast(this.$f7.toast, {
                                text: error,
                                position: "bottom",
                                horizontalPosition: "center",
                                closeButton: true,
                                cssClass: "custom-toast",
                                closeTimeout: 4000,
                              });
                            }

                            this.$f7.preloader.hide();
                            return toast(this.$f7.toast, {
                              text: "OTP code sent",
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                          },
                        );
                      },
                    },
                    // button to cancel
                    {
                      text: "x",
                      color: "white",
                      cssClass: "otp-close",
                      onClick: (dialog, e) => {
                        this.setState({
                          ...this.state,
                          deliveryEdit: false,
                          updateDeliveryButton: "Save",
                        });
                        this.$f7.preloader.hide();
                      },
                    },
                    // button to continue
                    {
                      text: "Continue",
                      bold: true,
                      cssClass: "otp-continue",
                      keyCodes: [13],
                      close: false,
                      onClick: (dialog, e) => {
                        this.$f7.preloader.show();
                        // password
                        const password = dialog.$el.find(".dialog-input").val();

                        // Verify otp
                        verifyOneTimePassword(
                          {
                            password,
                            type: "delivery",
                            token: idToken,
                            uid: this.props.auth.uid,
                            reason: "Profile changes",
                          },
                          (error, success) => {
                            if (error || !success) {
                              this.$f7.preloader.hide();
                              return toast(this.$f7.toast, {
                                text: error,
                                position: "bottom",
                                horizontalPosition: "center",
                                closeButton: true,
                                cssClass: "custom-toast",
                                closeTimeout: 4000,
                              });
                            }

                            // close dialog
                            dialog.close();

                            if (editedDelivery.phone || editedDelivery.email) {
                              let checks = [];
                              if (editedDelivery.phone) {
                                if (editedDelivery.phone.trim().length !== 11) {
                                  this.$f7.preloader.hide();
                                  toast(this.$f7.toast, {
                                    text: "Invalid phone number. Phone number must be 11 digits.",
                                    position: "bottom",
                                    horizontalPosition: "center",
                                    closeButton: true,
                                    cssClass: "custom-toast",
                                    closeTimeout: 4000,
                                  });
                                  return this.setState({
                                    ...this.state,
                                    deliveryEdit: false,
                                    updateDeliveryButton: "Save",
                                  });
                                }
                                checks.push(
                                  isAllowedVendorsAndAgents({
                                    token: idToken,
                                    uid: this.props.auth.uid,
                                    details: {
                                      collection: "delivery",
                                      value: editedDelivery.phone,
                                      property: "phone",
                                    },
                                  }),
                                );
                              }

                              if (editedDelivery.email) {
                                // verify email
                                if (!isValidEmail(editedDelivery.email)) {
                                  this.$f7.preloader.hide();
                                  toast(this.$f7.toast, {
                                    text: "Invalid email address",
                                    position: "bottom",
                                    horizontalPosition: "center",
                                    closeButton: true,
                                    cssClass: "custom-toast",
                                    closeTimeout: 4000,
                                  });
                                  return this.setState({
                                    ...this.state,
                                    deliveryEdit: false,
                                    updateDeliveryButton: "Save",
                                  });
                                }
                                checks.push(
                                  isAllowedVendorsAndAgents({
                                    token: idToken,
                                    uid: this.props.auth.uid,
                                    details: {
                                      collection: "delivery",
                                      value: editedDelivery.email,
                                      property: "email",
                                    },
                                  }),
                                );
                              }

                              axios
                                .all(checks)
                                .then(
                                  axios.spread((resArray) => {
                                    editedDelivery = {
                                      ...this.props.delivery[
                                        this.props.auth.uid
                                      ].businessProfile,
                                      ...editedDelivery,
                                    };

                                    // check if image or logo is changed
                                    if (
                                      this.state.image === null ||
                                      this.state.image === ""
                                    ) {
                                      this.props.firestore
                                        .collection("delivery")
                                        .doc(this.props.auth.uid)
                                        .update({
                                          businessProfile: {
                                            ...editedDelivery,
                                          },
                                        })
                                        .then(() => {
                                          this.$f7.preloader.hide();
                                          toast(this.$f7.toast, {
                                            text: "Delivery profile details updated",
                                            position: "bottom",
                                            horizontalPosition: "center",
                                            closeButton: true,
                                            cssClass: "custom-toast",
                                            closeTimeout: 4000,
                                          });
                                          this.setState({
                                            ...this.state,
                                            deliveryEdit: false,
                                            updateDeliveryButton: "Save",
                                          });
                                        })
                                        .catch((error) => {
                                          this.$f7.preloader.hide();
                                          toast(this.$f7.toast, {
                                            text: handleErrors(error),
                                            position: "bottom",
                                            horizontalPosition: "center",
                                            closeButton: true,
                                            cssClass: "custom-toast",
                                            closeTimeout: 4000,
                                          });
                                          this.setState({
                                            ...this.state,
                                            deliveryEdit: false,
                                            updateDeliveryButton: "Save",
                                          });
                                        });
                                    } else {
                                      // validate image
                                      if (
                                        ![
                                          "image/jpg",
                                          "image/png",
                                          "image/jpeg",
                                        ].includes(this.state.image.type)
                                      ) {
                                        this.$f7.preloader.hide();
                                        this.setState({
                                          ...this.state,
                                          deliveryEdit: false,
                                          updateDeliveryButton: "Save",
                                        });
                                        return toast(this.$f7.toast, {
                                          text: `${text} should be a valid image`,
                                          position: "bottom",
                                          horizontalPosition: "center",
                                          closeButton: true,
                                          cssClass: "custom-toast",
                                          closeTimeout: 4000,
                                        });
                                      }

                                      if (this.state.image.size > 10000000) {
                                        this.$f7.preloader.hide();
                                        this.setState({
                                          ...this.state,
                                          deliveryEdit: false,
                                          updateDeliveryButton: "Save",
                                        });
                                        return toast(this.$f7.toast, {
                                          text: `${text} should be below 10MB`,
                                          position: "bottom",
                                          horizontalPosition: "center",
                                          closeButton: true,
                                          cssClass: "custom-toast",
                                          closeTimeout: 4000,
                                        });
                                      }

                                      // delete old logo
                                      deleteFiles(
                                        this.props.storage,
                                        this.props.delivery[this.props.auth.uid]
                                          .businessProfile.images.logo.path,
                                        (error, success) => {
                                          if (
                                            error &&
                                            error.code !==
                                              "storage/object-not-found"
                                          ) {
                                            this.$f7.preloader.hide();
                                            this.setState({
                                              ...this.state,
                                              deliveryEdit: false,
                                              updateDeliveryButton: "Save",
                                            });
                                            return toast(this.$f7.toast, {
                                              text: handleErrors(error),
                                              position: "bottom",
                                              horizontalPosition: "center",
                                              closeButton: true,
                                              cssClass: "custom-toast",
                                              closeTimeout: 4000,
                                            });
                                          }

                                          uploadFile(
                                            this.props.storage,
                                            "businesslogo",
                                            this.props.auth.uid,
                                            this.state.image,
                                            (error, imageObject) => {
                                              if (error) {
                                                this.$f7.preloader.hide();
                                                this.setState({
                                                  ...this.state,
                                                  deliveryEdit: false,
                                                  updateDeliveryButton: "Save",
                                                });
                                                return toast(this.$f7.toast, {
                                                  text: handleErrors(error),
                                                  position: "bottom",
                                                  horizontalPosition: "center",
                                                  closeButton: true,
                                                  cssClass: "custom-toast",
                                                  closeTimeout: 4000,
                                                });
                                              }

                                              editedDelivery = {
                                                ...editedDelivery,
                                                images: {
                                                  ...editedDelivery.images,
                                                  logo: imageObject,
                                                },
                                              };

                                              this.props.firestore
                                                .collection("delivery")
                                                .doc(this.props.auth.uid)
                                                .update({
                                                  businessProfile: {
                                                    ...editedDelivery,
                                                  },
                                                })
                                                .then(() => {
                                                  this.$f7.preloader.hide();
                                                  toast(this.$f7.toast, {
                                                    text: "Delivery profile details updated",
                                                    position: "bottom",
                                                    horizontalPosition:
                                                      "center",
                                                    closeButton: true,
                                                    cssClass: "custom-toast",
                                                    closeTimeout: 4000,
                                                  });
                                                  this.setState({
                                                    ...this.state,
                                                    deliveryEdit: false,
                                                    updateDeliveryButton:
                                                      "Save",
                                                  });
                                                })
                                                .catch((error) => {
                                                  this.$f7.preloader.hide();
                                                  toast(this.$f7.toast, {
                                                    text: handleErrors(error),
                                                    position: "bottom",
                                                    horizontalPosition:
                                                      "center",
                                                    closeButton: true,
                                                    cssClass: "custom-toast",
                                                    closeTimeout: 4000,
                                                  });
                                                  this.setState({
                                                    ...this.state,
                                                    deliveryEdit: false,
                                                    updateDeliveryButton:
                                                      "Save",
                                                  });
                                                });
                                            },
                                          );
                                        },
                                      );
                                    }
                                  }),
                                )
                                .catch((error) => {
                                  this.$f7.preloader.hide();
                                  if (error.response) {
                                    toast(this.$f7.toast, {
                                      text: error.response.data.message,
                                      position: "bottom",
                                      horizontalPosition: "center",
                                      closeButton: true,
                                      cssClass: "custom-toast",
                                      closeTimeout: 4000,
                                    });
                                  } else if (error.request) {
                                    toast(this.$f7.toast, {
                                      text: error.request,
                                      position: "bottom",
                                      horizontalPosition: "center",
                                      closeButton: true,
                                      cssClass: "custom-toast",
                                      closeTimeout: 4000,
                                    });
                                  } else {
                                    // Something happened in setting up the request that triggered an Error
                                    toast(this.$f7.toast, {
                                      text: error.message,
                                      position: "bottom",
                                      horizontalPosition: "center",
                                      closeButton: true,
                                      cssClass: "custom-toast",
                                      closeTimeout: 4000,
                                    });
                                  }
                                  return this.setState({
                                    ...this.state,
                                    merchantEdit: false,
                                    updateMerchantButton: "Save",
                                  });
                                });
                            } else {
                              editedDelivery = {
                                ...this.props.delivery[this.props.auth.uid]
                                  .businessProfile,
                                ...editedDelivery,
                              };

                              // check if image or logo is changed
                              if (
                                this.state.image === null ||
                                this.state.image === ""
                              ) {
                                this.props.firestore
                                  .collection("delivery")
                                  .doc(this.props.auth.uid)
                                  .update({
                                    businessProfile: {
                                      ...editedDelivery,
                                    },
                                  })
                                  .then(() => {
                                    this.$f7.preloader.hide();
                                    toast(this.$f7.toast, {
                                      text: "Delivery profile details updated",
                                      position: "bottom",
                                      horizontalPosition: "center",
                                      closeButton: true,
                                      cssClass: "custom-toast",
                                      closeTimeout: 4000,
                                    });
                                    this.setState({
                                      ...this.state,
                                      deliveryEdit: false,
                                      updateDeliveryButton: "Save",
                                    });
                                  })
                                  .catch((error) => {
                                    this.$f7.preloader.hide();
                                    toast(this.$f7.toast, {
                                      text: handleErrors(error),
                                      position: "bottom",
                                      horizontalPosition: "center",
                                      closeButton: true,
                                      cssClass: "custom-toast",
                                      closeTimeout: 4000,
                                    });
                                    this.setState({
                                      ...this.state,
                                      deliveryEdit: false,
                                      updateDeliveryButton: "Save",
                                    });
                                  });
                              } else {
                                // validate image
                                if (
                                  ![
                                    "image/jpg",
                                    "image/png",
                                    "image/jpeg",
                                  ].includes(this.state.image.type)
                                ) {
                                  this.$f7.preloader.hide();
                                  this.setState({
                                    ...this.state,
                                    deliveryEdit: false,
                                    updateDeliveryButton: "Save",
                                  });
                                  return toast(this.$f7.toast, {
                                    text: `${text} should be a valid image`,
                                    position: "bottom",
                                    horizontalPosition: "center",
                                    closeButton: true,
                                    cssClass: "custom-toast",
                                    closeTimeout: 4000,
                                  });
                                }

                                if (this.state.image.size > 10000000) {
                                  this.$f7.preloader.hide();
                                  this.setState({
                                    ...this.state,
                                    deliveryEdit: false,
                                    updateDeliveryButton: "Save",
                                  });
                                  return toast(this.$f7.toast, {
                                    text: `${text} should be below 10MB`,
                                    position: "bottom",
                                    horizontalPosition: "center",
                                    closeButton: true,
                                    cssClass: "custom-toast",
                                    closeTimeout: 4000,
                                  });
                                }

                                // delete old logo
                                deleteFiles(
                                  this.props.storage,
                                  this.props.delivery[this.props.auth.uid]
                                    .businessProfile.images.logo.path,
                                  (error, success) => {
                                    if (
                                      error &&
                                      error.code !== "storage/object-not-found"
                                    ) {
                                      this.$f7.preloader.hide();
                                      this.setState({
                                        ...this.state,
                                        deliveryEdit: false,
                                        updateDeliveryButton: "Save",
                                      });
                                      return toast(this.$f7.toast, {
                                        text: handleErrors(error),
                                        position: "bottom",
                                        horizontalPosition: "center",
                                        closeButton: true,
                                        cssClass: "custom-toast",
                                        closeTimeout: 4000,
                                      });
                                    }

                                    uploadFile(
                                      this.props.storage,
                                      "businesslogo",
                                      this.props.auth.uid,
                                      this.state.image,
                                      (error, imageObject) => {
                                        if (error) {
                                          this.$f7.preloader.hide();
                                          this.setState({
                                            ...this.state,
                                            deliveryEdit: false,
                                            updateDeliveryButton: "Save",
                                          });
                                          return toast(this.$f7.toast, {
                                            text: handleErrors(error),
                                            position: "bottom",
                                            horizontalPosition: "center",
                                            closeButton: true,
                                            cssClass: "custom-toast",
                                            closeTimeout: 4000,
                                          });
                                        }

                                        editedDelivery = {
                                          ...editedDelivery,
                                          images: {
                                            ...editedDelivery.images,
                                            logo: imageObject,
                                          },
                                        };

                                        this.props.firestore
                                          .collection("delivery")
                                          .doc(this.props.auth.uid)
                                          .update({
                                            businessProfile: {
                                              ...editedDelivery,
                                            },
                                          })
                                          .then(() => {
                                            this.$f7.preloader.hide();
                                            toast(this.$f7.toast, {
                                              text: "Delivery profile details updated",
                                              position: "bottom",
                                              horizontalPosition: "center",
                                              closeButton: true,
                                              cssClass: "custom-toast",
                                              closeTimeout: 4000,
                                            });
                                            this.setState({
                                              ...this.state,
                                              deliveryEdit: false,
                                              updateDeliveryButton: "Save",
                                            });
                                          })
                                          .catch((error) => {
                                            this.$f7.preloader.hide();
                                            toast(this.$f7.toast, {
                                              text: handleErrors(error),
                                              position: "bottom",
                                              horizontalPosition: "center",
                                              closeButton: true,
                                              cssClass: "custom-toast",
                                              closeTimeout: 4000,
                                            });
                                            this.setState({
                                              ...this.state,
                                              deliveryEdit: false,
                                              updateDeliveryButton: "Save",
                                            });
                                          });
                                      },
                                    );
                                  },
                                );
                              }
                            }
                          },
                        );
                      },
                    },
                  ],
                })
                .open();
            },
          );
        })
        .catch((error) => {
          this.$f7.preloader.hide();
          toast(this.$f7.toast, {
            text: handleErrors(error),
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
          return this.setState({
            ...this.state,
            deliveryEdit: false,
            updateDeliveryButton: "Save",
          });
        });
    } else {
      this.setState({
        ...this.state,
        deliveryEdit: false,
        updateDeliveryButton: "Save",
      });
    }
  }

  updateProfile() {
    this.setState({
      ...this.state,
      updateProfileButton: "Saving...",
      merchantEdit: false,
      deliveryEdit: false,
      partnersEdit: false,
    });
    const editedProfile = {};

    Object.keys(this.state.profile).forEach((key) => {
      if (this.state.profile[key] !== this.props.profile[key]) {
        editedProfile[key] = this.state.profile[key];
      }
    });

    if (Object.keys(editedProfile).length > 0) {
      let error = false;

      Object.keys(editedProfile).forEach((key) => {
        if (
          key !== "homeLocation" &&
          key !== "workLocation" &&
          editedProfile[key].trim() === ""
        ) {
          error = true;
        }

        if (
          (key === "homeLocation" &&
            editedProfile[key].address.trim() !== "" &&
            !editedProfile[key].geoLoc) ||
          (key === "workLocation" &&
            editedProfile[key].address.trim() !== "" &&
            !editedProfile[key].geoLoc)
        ) {
          error = true;
        }
      });

      if (error) {
        this.setState({
          ...this.state,
          updateProfileButton: "Save Profile",
        });

        return toast(this.$f7.toast, {
          text: "Fields cannot be empty. If you are adding a home or work address, please select from the dropdown.",
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      }

      editedProfile.lastUpdated = Date.now();

      this.$f7.preloader.show();
      this.props.firebase
        .auth()
        .currentUser.getIdToken(true)
        .then((idToken) => {
          // send OTP to merchant's email
          sendOneTimePassword(
            {
              type: "users",
              token: idToken,
              uid: this.props.auth.uid,
              reason: "Profile changes",
            },
            (error, sent) => {
              if (error || !sent) {
                this.setState({
                  ...this.state,
                  edit: false,
                  updateProfileButton: "Save Profile",
                });
                this.$f7.preloader.hide();
                return toast(this.$f7.toast, {
                  text: error,
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
              }

              // open a dialog to confirm OTP
              this.$f7.preloader.hide();
              this.$f7.dialog
                .create({
                  title: "OTP CODE",
                  cssClass: "otp-code-modal",
                  text: "Confirm changes by filling in the OTP code sent to your email address",
                  content: `<input class="dialog-input split-input" type="password" maxlength="4"/>`,
                  buttons: [
                    // button to resend otp
                    {
                      text: "Resend Code",
                      color: "gray",
                      cssClass: "otp-resend",

                      close: false,
                      onClick: (dialog, e) => {
                        this.$f7.preloader.show();
                        sendOneTimePassword(
                          {
                            type: "users",
                            token: idToken,
                            uid: this.props.auth.uid,
                            reason: "Profile changes",
                          },
                          (error, sent) => {
                            if (error || !sent) {
                              this.setState({
                                ...this.state,
                                edit: false,
                                updateProfileButton: "Save Profile",
                              });

                              this.$f7.preloader.hide();
                              return toast(this.$f7.toast, {
                                text: error,
                                position: "bottom",
                                horizontalPosition: "center",
                                closeButton: true,
                                cssClass: "custom-toast",
                                closeTimeout: 4000,
                              });
                            }

                            this.$f7.preloader.hide();
                            return toast(this.$f7.toast, {
                              text: "OTP code sent",
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                          },
                        );
                      },
                    },
                    // button to cancel
                    {
                      text: "x",
                      color: "white",
                      cssClass: "otp-close",
                      onClick: (dialog, e) => {
                        this.setState({
                          ...this.state,
                          edit: false,
                          updateProfileButton: "Save Profile",
                        });
                        this.$f7.preloader.hide();
                      },
                    },
                    // button to continue
                    {
                      text: "Continue",
                      bold: true,
                      cssClass: "otp-continue",
                      keyCodes: [13],
                      close: false,
                      onClick: (dialog, e) => {
                        this.$f7.preloader.show();
                        // password
                        const password = dialog.$el.find(".dialog-input").val();

                        // Verify otp
                        verifyOneTimePassword(
                          {
                            password,
                            type: "users",
                            token: idToken,
                            uid: this.props.auth.uid,
                            reason: "Profile changes",
                          },
                          (error, success) => {
                            if (error || !success) {
                              this.$f7.preloader.hide();
                              return toast(this.$f7.toast, {
                                text: error,
                                position: "bottom",
                                horizontalPosition: "center",
                                closeButton: true,
                                cssClass: "custom-toast",
                                closeTimeout: 4000,
                              });
                            }

                            // close dialog
                            dialog.close();

                            if (editedProfile.email) {
                              const user =
                                this.props.firebase.auth().currentUser;

                              user
                                .updateEmail(editedProfile.email)
                                .then(() => {
                                  if (editedProfile.phoneNumber) {
                                    if (
                                      editedProfile.phoneNumber.trim()
                                        .length !== 11
                                    ) {
                                      this.$f7.preloader.hide();
                                      toast(this.$f7.toast, {
                                        text: "Invalid phone number. Phone number must be 11 digits.",
                                        position: "bottom",
                                        horizontalPosition: "center",
                                        closeButton: true,
                                        cssClass: "custom-toast",
                                        closeTimeout: 4000,
                                      });
                                      return this.setState({
                                        ...this.state,
                                        updateProfileButton: "Save Profile",
                                      });
                                    }

                                    isAllowed(
                                      {
                                        token: idToken,
                                        uid: this.props.auth.uid,
                                        details: {
                                          collection: "users",
                                          value: editedProfile.phoneNumber,
                                          property: "phoneNumber",
                                        },
                                      },
                                      (error, isAllowed) => {
                                        if (error) {
                                          this.$f7.preloader.hide();
                                          this.setState({
                                            ...this.state,
                                            updateProfileButton: "Save Profile",
                                          });
                                          return toast(this.$f7.toast, {
                                            text: error,
                                            position: "bottom",
                                            horizontalPosition: "center",
                                            closeButton: true,
                                            cssClass: "custom-toast",
                                            closeTimeout: 4000,
                                          });
                                        }

                                        this.props.firestore
                                          .collection("users")
                                          .doc(this.props.auth.uid)
                                          .update(editedProfile)
                                          .then(() => {
                                            this.$f7.preloader.hide();
                                            toast(this.$f7.toast, {
                                              text: "Profile Updated",
                                              position: "bottom",
                                              horizontalPosition: "center",
                                              closeButton: true,
                                              cssClass: "custom-toast",
                                              closeTimeout: 4000,
                                            });
                                            this.setState({
                                              ...this.state,
                                              edit: false,
                                              updateProfileButton:
                                                "Save Profile",
                                            });
                                          })
                                          .catch((error) => {
                                            this.$f7.preloader.hide();
                                            toast(this.$f7.toast, {
                                              text: handleErrors(error),
                                              position: "bottom",
                                              horizontalPosition: "center",
                                              closeButton: true,
                                              cssClass: "custom-toast",
                                              closeTimeout: 4000,
                                            });
                                            this.setState({
                                              ...this.state,
                                              edit: false,
                                              updateProfileButton:
                                                "Save Profile",
                                            });
                                          });
                                      },
                                    );
                                  } else {
                                    this.props.firestore
                                      .collection("users")
                                      .doc(this.props.auth.uid)
                                      .update(editedProfile)
                                      .then(() => {
                                        this.$f7.preloader.hide();
                                        toast(this.$f7.toast, {
                                          text: "Profile Updated",
                                          position: "bottom",
                                          horizontalPosition: "center",
                                          closeButton: true,
                                          cssClass: "custom-toast",
                                          closeTimeout: 4000,
                                        });
                                        this.setState({
                                          ...this.state,
                                          edit: false,
                                          updateProfileButton: "Save Profile",
                                        });
                                      })
                                      .catch((error) => {
                                        this.$f7.preloader.hide();
                                        toast(this.$f7.toast, {
                                          text: handleErrors(error),
                                          position: "bottom",
                                          horizontalPosition: "center",
                                          closeButton: true,
                                          cssClass: "custom-toast",
                                          closeTimeout: 4000,
                                        });
                                        this.setState({
                                          ...this.state,
                                          edit: false,
                                          updateProfileButton: "Save Profile",
                                        });
                                      });
                                  }
                                })
                                .catch((error) => {
                                  this.$f7.preloader.hide();
                                  toast(this.$f7.toast, {
                                    text: handleErrors(error),
                                    position: "bottom",
                                    horizontalPosition: "center",
                                    closeButton: true,
                                    cssClass: "custom-toast",
                                    closeTimeout: 4000,
                                  });
                                  this.setState({
                                    ...this.state,
                                    edit: false,
                                    updateProfileButton: "Save Profile",
                                  });
                                });
                            } else {
                              if (editedProfile.phoneNumber) {
                                if (
                                  editedProfile.phoneNumber.trim().length !== 11
                                ) {
                                  this.$f7.preloader.hide();
                                  toast(this.$f7.toast, {
                                    text: "Invalid phone number. Phone number must be 11 digits.",
                                    position: "bottom",
                                    horizontalPosition: "center",
                                    closeButton: true,
                                    cssClass: "custom-toast",
                                    closeTimeout: 4000,
                                  });
                                  return this.setState({
                                    ...this.state,
                                    updateProfileButton: "Save Profile",
                                  });
                                }

                                isAllowed(
                                  {
                                    token: idToken,
                                    uid: this.props.auth.uid,
                                    details: {
                                      collection: "users",
                                      value: editedProfile.phoneNumber,
                                      property: "phoneNumber",
                                    },
                                  },
                                  (error, isAllowed) => {
                                    if (error) {
                                      this.$f7.preloader.hide();
                                      this.setState({
                                        ...this.state,
                                        updateProfileButton: "Save Profile",
                                      });
                                      return toast(this.$f7.toast, {
                                        text: error,
                                        position: "bottom",
                                        horizontalPosition: "center",
                                        closeButton: true,
                                        cssClass: "custom-toast",
                                        closeTimeout: 4000,
                                      });
                                    }

                                    this.props.firestore
                                      .collection("users")
                                      .doc(this.props.auth.uid)
                                      .update(editedProfile)
                                      .then(() => {
                                        this.$f7.preloader.hide();
                                        toast(this.$f7.toast, {
                                          text: "Profile Updated",
                                          position: "bottom",
                                          horizontalPosition: "center",
                                          closeButton: true,
                                          cssClass: "custom-toast",
                                          closeTimeout: 4000,
                                        });
                                        this.setState({
                                          ...this.state,
                                          edit: false,
                                          updateProfileButton: "Save Profile",
                                        });
                                      })
                                      .catch((error) => {
                                        this.$f7.preloader.hide();
                                        toast(this.$f7.toast, {
                                          text: handleErrors(error),
                                          position: "bottom",
                                          horizontalPosition: "center",
                                          closeButton: true,
                                          cssClass: "custom-toast",
                                          closeTimeout: 4000,
                                        });
                                        this.setState({
                                          ...this.state,
                                          edit: false,
                                          updateProfileButton: "Save Profile",
                                        });
                                      });
                                  },
                                );
                              } else {
                                this.props.firestore
                                  .collection("users")
                                  .doc(this.props.auth.uid)
                                  .update(editedProfile)
                                  .then(() => {
                                    this.$f7.preloader.hide();
                                    toast(this.$f7.toast, {
                                      text: "Profile Updated",
                                      position: "bottom",
                                      horizontalPosition: "center",
                                      closeButton: true,
                                      cssClass: "custom-toast",
                                      closeTimeout: 4000,
                                    });
                                    this.setState({
                                      ...this.state,
                                      edit: false,
                                      updateProfileButton: "Save Profile",
                                    });
                                  })
                                  .catch((error) => {
                                    this.$f7.preloader.hide();
                                    toast(this.$f7.toast, {
                                      text: handleErrors(error),
                                      position: "bottom",
                                      horizontalPosition: "center",
                                      closeButton: true,
                                      cssClass: "custom-toast",
                                      closeTimeout: 4000,
                                    });
                                    this.setState({
                                      ...this.state,
                                      edit: false,
                                      updateProfileButton: "Save Profile",
                                    });
                                  });
                              }
                            }
                          },
                        );
                      },
                    },
                  ],
                })
                .open();
            },
          );
        })
        .catch((error) => {
          this.$f7.preloader.hide();
          this.setState({
            ...this.state,
            edit: false,
            updateProfileButton: "Save Profile",
          });
          return toast(this.$f7.toast, {
            text: handleErrors(error),
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
        });
    } else {
      this.setState({
        ...this.state,
        edit: false,
        updateProfileButton: "Save Profile",
      });
    }
  }

  updatePartners() {
    this.setState({
      ...this.state,
      updatePartnersButton: "Saving...",
      edit: false,
      merchantEdit: false,
      deliveryEdit: false,
    });
    let editedPartners = {};

    Object.keys(this.state.partners).forEach((key) => {
      if (key !== "businessLogo") {
        if (
          key === "geoLoc" &&
          (this.state.partners[key].lat !==
            this.props.partners[this.props.auth.uid].businessProfile[key].lat ||
            this.state.partners[key].lng !==
              this.props.partners[this.props.auth.uid].businessProfile[key].lng)
        ) {
          editedPartners[key] = { ...this.state.partners[key] };
        }

        if (
          key !== "geoLoc" &&
          this.state.partners[key] !==
            this.props.partners[this.props.auth.uid].businessProfile[key]
        ) {
          editedPartners[key] = this.state.partners[key];
        }
      }
    });

    if (
      Object.keys(editedPartners).length > 0 ||
      this.state.image !== null ||
      this.state.image !== ""
    ) {
      if (Object.keys(editedPartners).length > 0) {
        let error = false;
        Object.keys(editedPartners).forEach((key) => {
          if (key !== "geoLoc" && editedPartners[key].trim() === "") {
            error = true;
          }
        });

        if (error) {
          toast(this.$f7.toast, {
            text: "Fields cannot be empty",
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
          return this.setState({
            ...this.state,
            partnersEdit: false,
            updatePartnersButton: "Save",
          });
        }
      }

      this.$f7.preloader.show();

      this.props.firebase
        .auth()
        .currentUser.getIdToken(true)
        .then((idToken) => {
          // send OTP to merchant's email
          sendOneTimePassword(
            {
              type: "partners",
              token: idToken,
              uid: this.props.auth.uid,
              reason: "Profile changes",
            },
            (error, sent) => {
              if (error || !sent) {
                this.setState({
                  ...this.state,
                  partnersEdit: false,
                  updatePartnersButton: "Save",
                });
                this.$f7.preloader.hide();
                return toast(this.$f7.toast, {
                  text: error,
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
              }

              // open a dialog to confirm OTP
              this.$f7.preloader.hide();
              this.$f7.dialog
                .create({
                  title: "OTP CODE",
                  cssClass: "otp-code-modal",
                  text: "Confirm changes by filling in the OTP code sent to your email address",
                  content: `<input class="dialog-input split-input" type="password" maxlength="4"/>`,
                  buttons: [
                    // button to resend otp
                    {
                      text: "Resend Code",
                      color: "gray",
                      cssClass: "otp-resend",

                      close: false,
                      onClick: (dialog, e) => {
                        this.$f7.preloader.show();
                        sendOneTimePassword(
                          {
                            type: "partners",
                            token: idToken,
                            uid: this.props.auth.uid,
                            reason: "Profile changes",
                          },
                          (error, sent) => {
                            if (error || !sent) {
                              this.setState({
                                ...this.state,
                                partnersEdit: false,
                                updatePartnersButton: "Save",
                              });

                              this.$f7.preloader.hide();
                              return toast(this.$f7.toast, {
                                text: error,
                                position: "bottom",
                                horizontalPosition: "center",
                                closeButton: true,
                                cssClass: "custom-toast",
                                closeTimeout: 4000,
                              });
                            }

                            this.$f7.preloader.hide();
                            return toast(this.$f7.toast, {
                              text: "OTP code sent",
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                          },
                        );
                      },
                    },
                    // button to cancel
                    {
                      text: "x",
                      color: "white",
                      cssClass: "otp-close",
                      onClick: (dialog, e) => {
                        this.setState({
                          ...this.state,
                          partnersEdit: false,
                          updatePartnersButton: "Save",
                        });
                        this.$f7.preloader.hide();
                      },
                    },
                    // button to continue
                    {
                      text: "Continue",
                      bold: true,
                      cssClass: "otp-continue",
                      keyCodes: [13],
                      close: false,
                      onClick: (dialog, e) => {
                        this.$f7.preloader.show();
                        // password
                        const password = dialog.$el.find(".dialog-input").val();

                        // Verify otp
                        verifyOneTimePassword(
                          {
                            password,
                            type: "partners",
                            token: idToken,
                            uid: this.props.auth.uid,
                            reason: "Profile changes",
                          },
                          (error, success) => {
                            if (error || !success) {
                              this.$f7.preloader.hide();
                              return toast(this.$f7.toast, {
                                text: error,
                                position: "bottom",
                                horizontalPosition: "center",
                                closeButton: true,
                                cssClass: "custom-toast",
                                closeTimeout: 4000,
                              });
                            }

                            // close dialog
                            dialog.close();

                            if (editedPartners.phone || editedPartners.email) {
                              this.props.firebase
                                .auth()
                                .currentUser.getIdToken(true)
                                .then((idToken) => {
                                  let checks = [];
                                  if (editedPartners.phone) {
                                    if (
                                      editedPartners.phone.trim().length !== 11
                                    ) {
                                      this.$f7.preloader.hide();
                                      toast(this.$f7.toast, {
                                        text: "Invalid phone number. Phone number must be 11 digits.",
                                        position: "bottom",
                                        horizontalPosition: "center",
                                        closeButton: true,
                                        cssClass: "custom-toast",
                                        closeTimeout: 4000,
                                      });
                                      return this.setState({
                                        ...this.state,
                                        partnersEdit: false,
                                        updatePartnersButton: "Save",
                                      });
                                    }
                                    checks.push(
                                      isAllowedVendorsAndAgents({
                                        token: idToken,
                                        uid: this.props.auth.uid,
                                        details: {
                                          collection: "partners",
                                          value: editedPartners.phone,
                                          property: "phone",
                                        },
                                      }),
                                    );
                                  }

                                  if (editedPartners.email) {
                                    // verify email
                                    if (!isValidEmail(editedPartners.email)) {
                                      this.$f7.preloader.hide();
                                      toast(this.$f7.toast, {
                                        text: "Invalid email address",
                                        position: "bottom",
                                        horizontalPosition: "center",
                                        closeButton: true,
                                        cssClass: "custom-toast",
                                        closeTimeout: 4000,
                                      });
                                      return this.setState({
                                        ...this.state,
                                        partnersEdit: false,
                                        updatePartnersButton: "Save",
                                      });
                                    }
                                    checks.push(
                                      isAllowedVendorsAndAgents({
                                        token: idToken,
                                        uid: this.props.auth.uid,
                                        details: {
                                          collection: "partners",
                                          value: editedPartners.email,
                                          property: "email",
                                        },
                                      }),
                                    );
                                  }

                                  axios
                                    .all(checks)
                                    .then(
                                      axios.spread((...resArray) => {
                                        editedPartners = {
                                          ...this.props.partners[
                                            this.props.auth.uid
                                          ].businessProfile,
                                          ...editedPartners,
                                        };

                                        // check if image or logo is changed
                                        if (
                                          this.state.image === null ||
                                          this.state.image === ""
                                        ) {
                                          this.props.firestore
                                            .collection("partners")
                                            .doc(this.props.auth.uid)
                                            .update({
                                              businessProfile: {
                                                ...editedPartners,
                                              },
                                            })
                                            .then(() => {
                                              this.$f7.preloader.hide();
                                              toast(this.$f7.toast, {
                                                text: "Profile details updated",
                                                position: "bottom",
                                                horizontalPosition: "center",
                                                closeButton: true,
                                                cssClass: "custom-toast",
                                                closeTimeout: 4000,
                                              });
                                              this.setState({
                                                ...this.state,
                                                partnersEdit: false,
                                                updatePartnersButton: "Save",
                                              });
                                            })
                                            .catch((error) => {
                                              this.$f7.preloader.hide();
                                              toast(this.$f7.toast, {
                                                text: handleErrors(error),
                                                position: "bottom",
                                                horizontalPosition: "center",
                                                closeButton: true,
                                                cssClass: "custom-toast",
                                                closeTimeout: 4000,
                                              });
                                              this.setState({
                                                ...this.state,
                                                partnersEdit: false,
                                                updatePartnersButton: "Save",
                                              });
                                            });
                                        } else {
                                          // validate image
                                          if (
                                            ![
                                              "image/jpg",
                                              "image/png",
                                              "image/jpeg",
                                            ].includes(this.state.image.type)
                                          ) {
                                            this.$f7.preloader.hide();
                                            this.setState({
                                              ...this.state,
                                              partnersEdit: false,
                                              updatePartnersButton: "Save",
                                            });
                                            return toast(this.$f7.toast, {
                                              text: `${text} should be a valid image`,
                                              position: "bottom",
                                              horizontalPosition: "center",
                                              closeButton: true,
                                              cssClass: "custom-toast",
                                              closeTimeout: 4000,
                                            });
                                          }

                                          if (
                                            this.state.image.size > 10000000
                                          ) {
                                            this.$f7.preloader.hide();
                                            this.setState({
                                              ...this.state,
                                              partnersEdit: false,
                                              updatePartnersButton: "Save",
                                            });
                                            return toast(this.$f7.toast, {
                                              text: `${text} should be below 10MB`,
                                              position: "bottom",
                                              horizontalPosition: "center",
                                              closeButton: true,
                                              cssClass: "custom-toast",
                                              closeTimeout: 4000,
                                            });
                                          }

                                          // delete old logo
                                          deleteFiles(
                                            this.props.storage,
                                            this.props.partners[
                                              this.props.auth.uid
                                            ].businessProfile.images.logo.path,
                                            (error, success) => {
                                              if (
                                                error &&
                                                error.code !==
                                                  "storage/object-not-found"
                                              ) {
                                                this.$f7.preloader.hide();
                                                this.setState({
                                                  ...this.state,
                                                  partnersEdit: false,
                                                  updatePartnersButton: "Save",
                                                });
                                                return toast(this.$f7.toast, {
                                                  text: handleErrors(error),
                                                  position: "bottom",
                                                  horizontalPosition: "center",
                                                  closeButton: true,
                                                  cssClass: "custom-toast",
                                                  closeTimeout: 4000,
                                                });
                                              }

                                              uploadFile(
                                                this.props.storage,
                                                "partners",
                                                this.props.auth.uid,
                                                this.state.image,
                                                (error, imageObject) => {
                                                  if (error) {
                                                    this.$f7.preloader.hide();
                                                    this.setState({
                                                      ...this.state,
                                                      partnersEdit: false,
                                                      updatePartnersButton:
                                                        "Save",
                                                    });
                                                    return toast(
                                                      this.$f7.toast,
                                                      {
                                                        text: handleErrors(
                                                          error,
                                                        ),
                                                        position: "bottom",
                                                        horizontalPosition:
                                                          "center",
                                                        closeButton: true,
                                                        cssClass:
                                                          "custom-toast",
                                                        closeTimeout: 4000,
                                                      },
                                                    );
                                                  }

                                                  editedPartners = {
                                                    ...editedPartners,
                                                    images: {
                                                      ...editedPartners.images,
                                                      logo: imageObject,
                                                    },
                                                  };

                                                  this.props.firestore
                                                    .collection("partners")
                                                    .doc(this.props.auth.uid)
                                                    .update({
                                                      businessProfile: {
                                                        ...editedPartners,
                                                      },
                                                    })
                                                    .then(() => {
                                                      this.$f7.preloader.hide();
                                                      toast(this.$f7.toast, {
                                                        text: "Profile details updated",
                                                        position: "bottom",
                                                        horizontalPosition:
                                                          "center",
                                                        closeButton: true,
                                                        cssClass:
                                                          "custom-toast",
                                                        closeTimeout: 4000,
                                                      });
                                                      this.setState({
                                                        ...this.state,
                                                        partnersEdit: false,
                                                        updatePartnersButton:
                                                          "Save",
                                                      });
                                                    })
                                                    .catch((error) => {
                                                      this.$f7.preloader.hide();
                                                      toast(this.$f7.toast, {
                                                        text: handleErrors(
                                                          error,
                                                        ),
                                                        position: "bottom",
                                                        horizontalPosition:
                                                          "center",
                                                        closeButton: true,
                                                        cssClass:
                                                          "custom-toast",
                                                        closeTimeout: 4000,
                                                      });
                                                      this.setState({
                                                        ...this.state,
                                                        partnersEdit: false,
                                                        updatePartnersButton:
                                                          "Save",
                                                      });
                                                    });
                                                },
                                              );
                                            },
                                          );
                                        }
                                      }),
                                    )
                                    .catch((error) => {
                                      this.$f7.preloader.hide();
                                      if (error.response) {
                                        toast(this.$f7.toast, {
                                          text: error.response.data.message,
                                          position: "bottom",
                                          horizontalPosition: "center",
                                          closeButton: true,
                                          cssClass: "custom-toast",
                                          closeTimeout: 4000,
                                        });
                                      } else if (error.request) {
                                        toast(this.$f7.toast, {
                                          text: error.request,
                                          position: "bottom",
                                          horizontalPosition: "center",
                                          closeButton: true,
                                          cssClass: "custom-toast",
                                          closeTimeout: 4000,
                                        });
                                      } else {
                                        // Something happened in setting up the request that triggered an Error
                                        toast(this.$f7.toast, {
                                          text: error.message,
                                          position: "bottom",
                                          horizontalPosition: "center",
                                          closeButton: true,
                                          cssClass: "custom-toast",
                                          closeTimeout: 4000,
                                        });
                                      }
                                      return this.setState({
                                        ...this.state,
                                        partnersEdit: false,
                                        updatePartnersButton: "Save",
                                      });
                                    });
                                })
                                .catch((error) => {
                                  this.$f7.preloader.hide();
                                  toast(this.$f7.toast, {
                                    text: handleErrors(error),
                                    position: "bottom",
                                    horizontalPosition: "center",
                                    closeButton: true,
                                    cssClass: "custom-toast",
                                    closeTimeout: 4000,
                                  });
                                  return this.setState({
                                    ...this.state,
                                    partnersEdit: false,
                                    updatePartnersButton: "Save",
                                  });
                                });
                            } else {
                              editedPartners = {
                                ...this.props.partners[this.props.auth.uid]
                                  .businessProfile,
                                ...editedPartners,
                              };

                              // check if image or logo is changed
                              if (
                                this.state.image === null ||
                                this.state.image === ""
                              ) {
                                this.props.firestore
                                  .collection("partners")
                                  .doc(this.props.auth.uid)
                                  .update({
                                    businessProfile: {
                                      ...editedPartners,
                                    },
                                  })
                                  .then(() => {
                                    this.$f7.preloader.hide();
                                    toast(this.$f7.toast, {
                                      text: "Profile details updated",
                                      position: "bottom",
                                      horizontalPosition: "center",
                                      closeButton: true,
                                      cssClass: "custom-toast",
                                      closeTimeout: 4000,
                                    });
                                    this.setState({
                                      ...this.state,
                                      partnersEdit: false,
                                      updatePartnersButton: "Save",
                                    });
                                  })
                                  .catch((error) => {
                                    this.$f7.preloader.hide();
                                    toast(this.$f7.toast, {
                                      text: handleErrors(error),
                                      position: "bottom",
                                      horizontalPosition: "center",
                                      closeButton: true,
                                      cssClass: "custom-toast",
                                      closeTimeout: 4000,
                                    });
                                    this.setState({
                                      ...this.state,
                                      partnersEdit: false,
                                      updatePartnersButton: "Save",
                                    });
                                  });
                              } else {
                                // validate image
                                if (
                                  ![
                                    "image/jpg",
                                    "image/png",
                                    "image/jpeg",
                                  ].includes(this.state.image.type)
                                ) {
                                  this.$f7.preloader.hide();
                                  this.setState({
                                    ...this.state,
                                    partnersEdit: false,
                                    updatePartnersButton: "Save",
                                  });
                                  return toast(this.$f7.toast, {
                                    text: `${text} should be a valid image`,
                                    position: "bottom",
                                    horizontalPosition: "center",
                                    closeButton: true,
                                    cssClass: "custom-toast",
                                    closeTimeout: 4000,
                                  });
                                }

                                if (this.state.image.size > 10000000) {
                                  this.$f7.preloader.hide();
                                  this.setState({
                                    ...this.state,
                                    partnersEdit: false,
                                    updatePartnersButton: "Save",
                                  });
                                  return toast(this.$f7.toast, {
                                    text: `${text} should be below 10MB`,
                                    position: "bottom",
                                    horizontalPosition: "center",
                                    closeButton: true,
                                    cssClass: "custom-toast",
                                    closeTimeout: 4000,
                                  });
                                }

                                // delete old logo
                                deleteFiles(
                                  this.props.storage,
                                  this.props.partners[this.props.auth.uid]
                                    .businessProfile.images.logo.path,
                                  (error, success) => {
                                    if (
                                      error &&
                                      error.code !== "storage/object-not-found"
                                    ) {
                                      this.$f7.preloader.hide();
                                      this.setState({
                                        ...this.state,
                                        partnersEdit: false,
                                        updatePartnersButton: "Save",
                                      });
                                      return toast(this.$f7.toast, {
                                        text: handleErrors(error),
                                        position: "bottom",
                                        horizontalPosition: "center",
                                        closeButton: true,
                                        cssClass: "custom-toast",
                                        closeTimeout: 4000,
                                      });
                                    }

                                    uploadFile(
                                      this.props.storage,
                                      "partners",
                                      this.props.auth.uid,
                                      this.state.image,
                                      (error, imageObject) => {
                                        if (error) {
                                          this.$f7.preloader.hide();
                                          this.setState({
                                            ...this.state,
                                            partnersEdit: false,
                                            updatePartnersButton: "Save",
                                          });
                                          return toast(this.$f7.toast, {
                                            text: handleErrors(error),
                                            position: "bottom",
                                            horizontalPosition: "center",
                                            closeButton: true,
                                            cssClass: "custom-toast",
                                            closeTimeout: 4000,
                                          });
                                        }

                                        editedPartners = {
                                          ...editedPartners,
                                          images: {
                                            ...editedPartners.images,
                                            logo: imageObject,
                                          },
                                        };

                                        this.props.firestore
                                          .collection("partners")
                                          .doc(this.props.auth.uid)
                                          .update({
                                            businessProfile: {
                                              ...editedPartners,
                                            },
                                          })
                                          .then(() => {
                                            this.$f7.preloader.hide();
                                            toast(this.$f7.toast, {
                                              text: "Profile details updated",
                                              position: "bottom",
                                              horizontalPosition: "center",
                                              closeButton: true,
                                              cssClass: "custom-toast",
                                              closeTimeout: 4000,
                                            });
                                            this.setState({
                                              ...this.state,
                                              partnersEdit: false,
                                              updatePartnersButton: "Save",
                                            });
                                          })
                                          .catch((error) => {
                                            this.$f7.preloader.hide();
                                            toast(this.$f7.toast, {
                                              text: handleErrors(error),
                                              position: "bottom",
                                              horizontalPosition: "center",
                                              closeButton: true,
                                              cssClass: "custom-toast",
                                              closeTimeout: 4000,
                                            });
                                            this.setState({
                                              ...this.state,
                                              partnersEdit: false,
                                              updatePartnersButton: "Save",
                                            });
                                          });
                                      },
                                    );
                                  },
                                );
                              }
                            }
                          },
                        );
                      },
                    },
                  ],
                })
                .open();
            },
          );
        })
        .catch((error) => {
          this.$f7.preloader.hide();
          toast(this.$f7.toast, {
            text: handleErrors(error),
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
          this.setState({
            ...this.state,
            partnersEdit: false,
            updatePartnersButton: "Save",
          });
        });
    } else {
      this.setState({
        ...this.state,
        partnersEdit: false,
        updatePartnersButton: "Save",
      });
    }
  }
}

const mapStateToProps = ({
  firebase: { auth, profile },
  DB: {
    docs: { merchants, delivery, loading, partners },
  },
}) => ({
  auth,
  profile,
  merchants: merchants || null,
  delivery: delivery || null,
  partners: partners || null,
  loadingDoc: loading,
});

const enhance = compose(
  withStorage,
  withFirestore,
  firebaseConnect,
  firestoreConnect((props) => [
    new Doc("merchants", props.auth.uid),
    new Doc("delivery", props.auth.uid),
    new Doc("partners", props.auth.uid),
  ]),
  connect(mapStateToProps),
);

export default enhance(Account);
